/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSON: { input: { [key: string]: any }; output: { [key: string]: any }; }
  Long: { input: number; output: number; }
  UUID: { input: string; output: string; }
};

export type AbsoluteDateRangeFilter = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type AdTypeV2 = {
  canonicalName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AddNzTrialInput = {
  formFields: Array<TrackingFormField>;
};

export type AddUserToTeamInput = {
  role: TeamMemberRole;
  teamId: Scalars['UUID']['input'];
  userId: Scalars['String']['input'];
};

export type AdvertiserDomain = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AiFilterItem = {
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type AiFilters = {
  aiAdvertiserV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCategoryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiFuelTypeV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiIndustryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiProductV1?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AiTag = {
  advertiser?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
};

export type AustraliaComplianceInput = {
  AANA_CHILDRENS_ADVERTISING_CODE?: InputMaybe<Array<Scalars['String']['input']>>;
  AANA_CODE_OF_ETHICS?: InputMaybe<Array<Scalars['String']['input']>>;
  AANA_ENVIRONMENTAL_CLAIMS_CODE?: InputMaybe<Array<Scalars['String']['input']>>;
  AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE?: InputMaybe<Array<Scalars['String']['input']>>;
  AANA_WAGERING_ADVERTISING_CODE?: InputMaybe<Array<Scalars['String']['input']>>;
  ABAC_CODE?: InputMaybe<Array<Scalars['String']['input']>>;
  FCAI_CODE?: InputMaybe<Array<Scalars['String']['input']>>;
  TGA_CODE?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AustraliaComplianceType = {
  AANA_CHILDRENS_ADVERTISING_CODE?: Maybe<Array<Scalars['String']['output']>>;
  AANA_CODE_OF_ETHICS?: Maybe<Array<Scalars['String']['output']>>;
  AANA_ENVIRONMENTAL_CLAIMS_CODE?: Maybe<Array<Scalars['String']['output']>>;
  AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE?: Maybe<Array<Scalars['String']['output']>>;
  AANA_WAGERING_ADVERTISING_CODE?: Maybe<Array<Scalars['String']['output']>>;
  ABAC_CODE?: Maybe<Array<Scalars['String']['output']>>;
  FCAI_CODE?: Maybe<Array<Scalars['String']['output']>>;
  TGA_CODE?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandV2 = {
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  industries?: Maybe<Array<IndustryV2>>;
  name: Scalars['String']['output'];
};

export type BrandsPaginationInfo = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
};

export type CachedStatus =
  | 'HIT'
  | 'MISS';

export type CampaignGroup = {
  aiAdType: Array<Scalars['String']['output']>;
  aiAdvertisers: Array<Scalars['String']['output']>;
  aiCategories: Array<Scalars['String']['output']>;
  aiIndustries: Array<Scalars['String']['output']>;
  aiProducts: Array<Scalars['String']['output']>;
  campaignName: Scalars['String']['output'];
  country: Scalars['String']['output'];
  creativeCount: Scalars['Int']['output'];
  firstAppeared: Scalars['String']['output'];
  lastAppeared: Scalars['String']['output'];
  mediaOwner: Array<Scalars['String']['output']>;
  mediaType: Array<Scalars['String']['output']>;
  publication: Array<Scalars['String']['output']>;
  publisher: Array<Scalars['String']['output']>;
  region: Array<Scalars['String']['output']>;
  status: CreativeStatusV2;
  thumbnailCreative: Scalars['String']['output'];
};

export type CampaignV2 = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CategoryNameInput = {
  category: Scalars['String']['input'];
  industry: Scalars['String']['input'];
};

export type CategoryV2 = {
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<IndustryV2>;
  name: Scalars['String']['output'];
};

export type ChangeOwnershipData = {
  report: ReportListItem;
  reportItems: Array<ShallowReportItem>;
};

export type Changeset = {
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ChangesetOrderBy = {
  field: ChangesetOrderByFields;
  order: OrderDirection;
};

export type ChangesetOrderByFields =
  | 'createdAt'
  | 'name'
  | 'updatedAt';

export type ChangesetPageInfo = {
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type ChangesetPagination = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type ChangesetQuery = {
  search: ChangesetResult;
};


export type ChangesetQuerySearchArgs = {
  orderBy?: InputMaybe<ChangesetOrderBy>;
  pagination?: InputMaybe<ChangesetPagination>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ChangesetStatus>>;
};

export type ChangesetResult = {
  items: Array<Changeset>;
  pageInfo: ChangesetPageInfo;
};

export type ChangesetStatus =
  | 'ARCHIVED'
  | 'DRAFT'
  | 'DRAFT_PREPARE_FAILED'
  | 'DRAFT_PREPARING'
  | 'DRAFT_READY'
  | 'LIVE'
  | 'PREVIOUS';

export type ColumnFilter = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignId?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  segment?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ColumnTotal = {
  column: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type ComparisonPeriod = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
};

export type CompliancCodes = {
  codeId: Scalars['String']['output'];
  codeName: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  industries: Array<Scalars['String']['output']>;
};

export type ComplianceCodeListResponse = {
  items: Array<CompliancCodes>;
};

export type ComplianceCountryCodesMapInput = {
  AU?: InputMaybe<AustraliaComplianceInput>;
};

export type ComplianceCountryCodesMapType = {
  AU?: Maybe<AustraliaComplianceType>;
};

export type ComplianceCreative = {
  complianceCodeId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creative?: Maybe<CreativeItemV3>;
  creativeId: Scalars['String']['output'];
  history: Array<ComplianceCreativeHistory>;
  notes: Array<Scalars['String']['output']>;
  numericalProgressStatus: Scalars['Int']['output'];
  progressStatus: ComplianceCreativeProgressStatus;
  shortlists?: Maybe<Array<Scalars['String']['output']>>;
  teamId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ComplianceCreativeHistory = {
  actor: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ComplianceCreativeListItem = ICreativeItem & {
  advertiserDomain?: Maybe<Scalars['String']['output']>;
  aiAdTypeV1?: Maybe<Scalars['String']['output']>;
  aiCampaignHeadlineV1?: Maybe<Array<Scalars['String']['output']>>;
  aiDemographicsV1?: Maybe<Array<Demographics>>;
  aiExtractedTextV1?: Maybe<Scalars['String']['output']>;
  aiSummaryInsightsV1?: Maybe<Array<Summary>>;
  aiTagsV1?: Maybe<Array<AiTag>>;
  aiTranscriptionTextV1?: Maybe<Scalars['String']['output']>;
  compliance?: Maybe<Array<ComplianceData>>;
  country?: Maybe<Scalars['String']['output']>;
  creative: Scalars['String']['output'];
  firstAppeared?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastAppeared?: Maybe<Scalars['Date']['output']>;
  mediaOwnerList: Array<MediaOwner>;
  mediaTypeList: Array<MediaTypeV2>;
  placementTypes?: Maybe<Array<Scalars['String']['output']>>;
  progressStatus?: Maybe<ComplianceCreativeProgressStatus>;
  publicationList: Array<PublicationV2>;
  publisherList: Array<Publisher>;
  regionList: Array<PublicationV2>;
  status: CreativeStatusV2;
};

export type ComplianceCreativeListPagination = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type ComplianceCreativeListPaginationInfo = {
  hasNextPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type ComplianceCreativeListQueryInput = {
  filters: ComplianceFilters;
  orderBy: ComplianceCreativeListSort;
  pagination: ComplianceCreativeListPagination;
};

export type ComplianceCreativeListResponse = {
  items: Array<ComplianceCreativeListItem>;
  paginationInfo: ComplianceCreativeListPaginationInfo;
};

export type ComplianceCreativeListSort = {
  field: ComplianceCreativeListSortField;
  order: OrderByOrders;
};

export type ComplianceCreativeListSortField =
  | 'complianceRank'
  | 'firstAppeared'
  | 'lastAppeared';

export type ComplianceCreativeListV2PaginationInfo = {
  mightHaveNextPage: Scalars['Boolean']['output'];
  nextPageCursor?: Maybe<Array<Scalars['String']['output']>>;
  receivedCreatives: Scalars['Int']['output'];
  requestedCreatives?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceCreativeListV2QueryInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Array<Scalars['String']['input']>>;
  filters: ComplianceFilters;
  maxCount?: InputMaybe<Scalars['Int']['input']>;
  orderBy: ComplianceCreativeListV2Sort;
};

export type ComplianceCreativeListV2Response = {
  items: Array<ComplianceCreativeListItem>;
  paginationInfo: ComplianceCreativeListV2PaginationInfo;
};

export type ComplianceCreativeListV2Sort = {
  field: ComplianceCreativeListV2SortField;
  order: OrderByOrders;
};

export type ComplianceCreativeListV2SortField =
  | 'complianceRank'
  | 'firstAppeared'
  | 'lastAppeared'
  | 'reviewStatus';

export type ComplianceCreativeProgressStatus =
  | 'furtherReviewRequired'
  | 'pendingReview'
  | 'safeAndComplete'
  | 'underInvestigation';

export type ComplianceCreativeUpdateMutationInput = {
  complianceCodeId: Scalars['String']['input'];
  creativeId: Scalars['String']['input'];
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  progressStatus?: InputMaybe<ComplianceCreativeProgressStatus>;
};

export type ComplianceCreativesQueryInput = {
  complianceCodeId: Scalars['String']['input'];
  shortlist: Scalars['String']['input'];
};

export type ComplianceCreativesSingleQueryInput = {
  complianceCodeId: Scalars['String']['input'];
  creativeId: Scalars['String']['input'];
};

export type ComplianceCsvInput = {
  filters: ComplianceFilters;
  includeReviewProgress?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy: ComplianceCreativeListSort;
};

export type ComplianceData = {
  compliance_code?: Maybe<Scalars['String']['output']>;
  compliance_code_id?: Maybe<Scalars['String']['output']>;
  compliance_ranking?: Maybe<Scalars['Int']['output']>;
  compliance_reason?: Maybe<Scalars['String']['output']>;
  compliance_risk_rating?: Maybe<ComplianceRiskRating>;
};

export type ComplianceDeleteShortlistMutationInput = {
  complianceCodeId: Scalars['String']['input'];
  shortlist: Scalars['String']['input'];
};

export type ComplianceFavoritesMutationInput = {
  complianceCodeId: Scalars['String']['input'];
  creativeId: Scalars['String']['input'];
  shortlist: Scalars['String']['input'];
};

export type ComplianceFilters = {
  advertiserDomain?: InputMaybe<Array<Scalars['String']['input']>>;
  aiAdTypeV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiAdvertiserV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCampaignHeadlineV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCategoryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiIndustryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiProductV1?: InputMaybe<Array<Scalars['String']['input']>>;
  complianceRiskRating?: InputMaybe<Array<ComplianceRiskRating>>;
  compliance_code_id: Scalars['String']['input'];
  country: Scalars['String']['input'];
  dateRangeFilter?: InputMaybe<CreativeListDateRangeFilterV2>;
  mediaOwner?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  placementType?: InputMaybe<Array<Scalars['String']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewStatus?: InputMaybe<Array<ComplianceCreativeProgressStatus>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<CreativeStatusV2>>;
};

export type ComplianceMutations = {
  addToShortlist: ComplianceCreative;
  removeFromShortlist?: Maybe<ComplianceCreative>;
  updateComplianceCreative: ComplianceCreative;
};


export type ComplianceMutationsAddToShortlistArgs = {
  input: ComplianceFavoritesMutationInput;
};


export type ComplianceMutationsRemoveFromShortlistArgs = {
  input: ComplianceFavoritesMutationInput;
};


export type ComplianceMutationsUpdateComplianceCreativeArgs = {
  input: ComplianceCreativeUpdateMutationInput;
};

export type CompliancePollingResponse = {
  csv: Scalars['String']['output'];
  errorJson: Scalars['String']['output'];
};

export type ComplianceQuery = {
  codeList: ComplianceCodeListResponse;
  creative: ComplianceCreative;
  creativeList: ComplianceCreativeListResponse;
  creativeListV2: ComplianceCreativeListV2Response;
  creatives?: Maybe<Array<ComplianceCreative>>;
  csv: CompliancePollingResponse;
  shortlists?: Maybe<Array<Scalars['String']['output']>>;
};


export type ComplianceQueryCreativeArgs = {
  input: ComplianceCreativesSingleQueryInput;
};


export type ComplianceQueryCreativeListArgs = {
  input: ComplianceCreativeListQueryInput;
};


export type ComplianceQueryCreativeListV2Args = {
  input: ComplianceCreativeListV2QueryInput;
};


export type ComplianceQueryCreativesArgs = {
  input: ComplianceCreativesQueryInput;
};


export type ComplianceQueryCsvArgs = {
  input: ComplianceCsvInput;
};


export type ComplianceQueryShortlistsArgs = {
  input: ComplianceShortlistsQueryInput;
};

export type ComplianceRiskRating =
  | 'high'
  | 'low'
  | 'medium';

export type ComplianceShortlistsQueryInput = {
  complianceCodeId: Scalars['String']['input'];
};

export type ConvertFiltersInput = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<CategoryNameInput>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConvertFiltersOutput = {
  adType?: Maybe<Array<Scalars['String']['output']>>;
  brand?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Array<Scalars['String']['output']>>;
  industry?: Maybe<Array<Scalars['String']['output']>>;
  mediaType?: Maybe<Array<Scalars['String']['output']>>;
  product?: Maybe<Array<Scalars['String']['output']>>;
  region?: Maybe<Array<Scalars['String']['output']>>;
};

export type ConvertNameToEntitiesInput = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaOwner?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaTypeSynonym?: InputMaybe<Array<Scalars['String']['input']>>;
  publication?: InputMaybe<Array<Scalars['String']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConvertNameToEntitiesOutput = {
  adType?: Maybe<Array<AdTypeV2>>;
  brand?: Maybe<Array<BrandV2>>;
  industry?: Maybe<Array<IndustryV2>>;
  mediaOwner?: Maybe<Array<MediaOwner>>;
  mediaType?: Maybe<Array<MediaTypeV2>>;
  mediaTypeSynonym?: Maybe<Array<MediaTypeV2>>;
  publication?: Maybe<Array<PublicationV2>>;
  publisher?: Maybe<Array<Publisher>>;
  region?: Maybe<Array<RegionV2>>;
};

export type CreateTeamWithInviteInput = {
  email: Scalars['String']['input'];
  inviterId: Scalars['String']['input'];
  teamName: Scalars['String']['input'];
};

export type CreativeDownloadInput = {
  creativeList: Array<Scalars['String']['input']>;
  downloadFilename: Scalars['String']['input'];
};

export type CreativeDownloadResult = {
  downloadLink: Scalars['String']['output'];
};

export type CreativeEmailSegmentInput = {
  fullPrimitive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreativeEmailSegmentUpdateInput = {
  aiAdvertiserV1?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  emailAlert?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
};

export type CreativeItemV2 = {
  adType?: Maybe<AdTypeV2>;
  advertiserDomain?: Maybe<Scalars['String']['output']>;
  advertiserName?: Maybe<Scalars['String']['output']>;
  aiAdTypeV1?: Maybe<Scalars['String']['output']>;
  aiAdvertisersV1?: Maybe<Array<Scalars['String']['output']>>;
  aiCampaignHeadlineV1?: Maybe<Array<Scalars['String']['output']>>;
  aiCategoriesV1?: Maybe<Array<Scalars['String']['output']>>;
  aiDemographicsV1?: Maybe<Array<Demographics>>;
  aiExtractedTextV1?: Maybe<Scalars['String']['output']>;
  aiIndustriesV1?: Maybe<Array<Scalars['String']['output']>>;
  aiProductsV1?: Maybe<Array<Scalars['String']['output']>>;
  aiSummaryInsightsV1?: Maybe<Array<Summary>>;
  aiTagsV1?: Maybe<Array<AiTag>>;
  aiTranscriptionTextV1?: Maybe<Scalars['String']['output']>;
  brandList: Array<BrandV2>;
  categoryList: Array<CategoryV2>;
  compliance?: Maybe<Array<ComplianceData>>;
  country?: Maybe<Scalars['String']['output']>;
  creative: Scalars['String']['output'];
  firstAppeared?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  industryList: Array<IndustryV2>;
  lastAppeared?: Maybe<Scalars['Date']['output']>;
  mediaOwnerList: Array<MediaOwner>;
  mediaTypeList: Array<MediaTypeV2>;
  placementTypes?: Maybe<Array<Scalars['String']['output']>>;
  productList: Array<ProductV2>;
  publicationList: Array<PublicationV2>;
  publisherList: Array<Publisher>;
  regionList: Array<PublicationV2>;
  status: CreativeStatusV2;
};

export type CreativeItemV3 = ICreativeItem & {
  advertiserDomain?: Maybe<Scalars['String']['output']>;
  aiAdTypeV1?: Maybe<Scalars['String']['output']>;
  aiCampaignHeadlineV1?: Maybe<Array<Scalars['String']['output']>>;
  aiDemographicsV1?: Maybe<Array<Demographics>>;
  aiExtractedTextV1?: Maybe<Scalars['String']['output']>;
  aiSummaryInsightsV1?: Maybe<Array<Summary>>;
  aiTagsV1?: Maybe<Array<AiTag>>;
  aiTranscriptionTextV1?: Maybe<Scalars['String']['output']>;
  compliance?: Maybe<Array<ComplianceData>>;
  country?: Maybe<Scalars['String']['output']>;
  creative: Scalars['String']['output'];
  firstAppeared?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastAppeared?: Maybe<Scalars['Date']['output']>;
  mediaOwnerList: Array<MediaOwner>;
  mediaTypeList: Array<MediaTypeV2>;
  placementTypes?: Maybe<Array<Scalars['String']['output']>>;
  publicationList: Array<PublicationV2>;
  publisherList: Array<Publisher>;
  regionList: Array<PublicationV2>;
  status: CreativeStatusV2;
};

export type CreativeListDateRangeFilterV2 = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
  relative?: InputMaybe<CreativeListRelativeDateRangeFilter>;
};

export type CreativeListFilterInputV2 = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserDomain?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserName?: InputMaybe<Array<Scalars['String']['input']>>;
  aiAdTypeV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiAdvertiserV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCampaignHeadlineV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCategoryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiFuelTypeV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiIndustryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiProductV1?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  campaign?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  compliance_code_id?: InputMaybe<Array<Scalars['String']['input']>>;
  compliance_ranking?: InputMaybe<Array<Scalars['Int']['input']>>;
  compliance_reason?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAtBetween?: InputMaybe<DateRange>;
  dateRangeFilter?: InputMaybe<CreativeListDateRangeFilterV2>;
  firstAppearedBetween?: InputMaybe<DateRange>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaOwner?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  placementType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  publication?: InputMaybe<Array<Scalars['ID']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<CreativeStatusV2>>;
};

export type CreativeListInputV2 = {
  australianAiTags?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<CreativeListFilterInputV2>;
  newZealandAiTags?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<CreativeListOrderByV2>;
  pagination?: InputMaybe<CreativeListPaginationV2>;
};

export type CreativeListOrderByV2 = {
  field: CreativeListOrderFieldV2;
  order: OrderByOrders;
};

export type CreativeListOrderFieldV2 =
  | 'firstAppeared'
  | 'lastAppeared'
  | 'score';

export type CreativeListPageV2 = {
  items: Array<CreativeItemV2>;
  paginationInfo?: Maybe<CreativeListPaginationInfoV2>;
  totalCount: Scalars['Int']['output'];
};

export type CreativeListPaginationInfoV2 = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type CreativeListPaginationV2 = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type CreativeListRelativeDateRangeFilter = {
  months: Scalars['Int']['input'];
};

export type CreativeMediaValueInput = {
  creativeId: Scalars['String']['input'];
};

export type CreativeMediaValueResponse = {
  date: Scalars['String']['output'];
  normalizedSpend: Scalars['Float']['output'];
};

export type CreativeQueryV2 = {
  creativeDownload: CreativeDownloadResult;
  creativeListV2: CreativeListPageV2;
  creativeMediaValue: Array<CreativeMediaValueResponse>;
  groupByCampaign: GroupByCampaignResult;
  publicCreativeItemV2: PublicCreativeItemV2;
};


export type CreativeQueryV2CreativeDownloadArgs = {
  input: CreativeDownloadInput;
};


export type CreativeQueryV2CreativeListV2Args = {
  input: CreativeListInputV2;
};


export type CreativeQueryV2CreativeMediaValueArgs = {
  input: CreativeMediaValueInput;
};


export type CreativeQueryV2GroupByCampaignArgs = {
  input: GroupByCampaignInput;
};


export type CreativeQueryV2PublicCreativeItemV2Args = {
  australianAiTags?: InputMaybe<Scalars['Boolean']['input']>;
  creativeId: Scalars['ID']['input'];
  newZealandAiTags?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreativeStatusV2 =
  | 'active'
  | 'inactive'
  | 'new';

export type DashboardBrandMediaValue = {
  change?: Maybe<Scalars['Float']['output']>;
  currentPeriod?: Maybe<Array<Maybe<DashboardBrandMediaValueItem>>>;
  currentPeriodTotal?: Maybe<Scalars['Float']['output']>;
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  previousPeriod?: Maybe<Array<Maybe<DashboardBrandMediaValueItem>>>;
  previousPeriodTotal?: Maybe<Scalars['Float']['output']>;
};

export type DashboardBrandMediaValueItem = {
  month?: Maybe<Scalars['String']['output']>;
  spend?: Maybe<Scalars['Float']['output']>;
};

export type DashboardBrands = {
  brand?: Maybe<BrandV2>;
  creatives?: Maybe<Array<Maybe<CreativeItemV2>>>;
  mediaValue?: Maybe<DashboardBrandMediaValue>;
};

export type DashboardQueryV3 = {
  followedBrands?: Maybe<DashboardResponse>;
  topBrands?: Maybe<DashboardResponse>;
};


export type DashboardQueryV3FollowedBrandsArgs = {
  input: DashboardQueryV3Input;
};


export type DashboardQueryV3TopBrandsArgs = {
  input: DashboardQueryV3Input;
};

export type DashboardQueryV3Input = {
  creativeCount: Scalars['Int']['input'];
  dateRangeFilter: DataTableDateRangeFilter;
  mediaValueV2?: InputMaybe<Scalars['Boolean']['input']>;
  mediaValueV3?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<MediaValuePagination>;
};

export type DashboardResponse = {
  brands?: Maybe<Array<DashboardBrands>>;
  paginationInfo?: Maybe<BrandsPaginationInfo>;
};

export type DataTableDateRangeFilter = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
  relative?: InputMaybe<MediaValueRelativeDateRangeFilter>;
  truncateMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type DateRange = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type DeletedStatus =
  | 'ACTIVE'
  | 'DELETED';

export type Demographics = {
  ageBracket?: Maybe<Scalars['String']['output']>;
  ageName?: Maybe<Scalars['String']['output']>;
  genderDistribution?: Maybe<DemographicsGenderDistribution>;
};

export type DemographicsGenderDistribution = {
  female?: Maybe<Scalars['Float']['output']>;
  male?: Maybe<Scalars['Float']['output']>;
  unspecified?: Maybe<Scalars['Float']['output']>;
};

export type DummyItem = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EntitiesById = {
  adType: Array<AdTypeV2>;
  brand: Array<BrandV2>;
  campaign: Array<CampaignV2>;
  category: Array<CategoryV2>;
  changeset: Array<Changeset>;
  industry: Array<IndustryV2>;
  mediaOwner: Array<MediaOwner>;
  mediaType: Array<MediaTypeV2>;
  product: Array<ProductV2>;
  publication: Array<PublicationV2>;
  publisher?: Maybe<Array<Publisher>>;
  region: Array<RegionV2>;
  segment: Array<SegmentV2>;
};

export type FilterAiResultV2 = {
  column: FilterAiColumn;
  items: FilterAiItemResponseV2;
  pageInfo?: Maybe<FilterTypeAiResultPageInfoV2>;
};

export type FilterAiColumn =
  | 'aiAdvertiserV1'
  | 'aiCategoryV1'
  | 'aiFuelTypeV1'
  | 'aiIndustryV1'
  | 'aiProductV1';

export type FilterAiEntitiesQuery = {
  filterAiEntitiesV2: FilterAiResultV2;
};


export type FilterAiEntitiesQueryFilterAiEntitiesV2Args = {
  filter?: InputMaybe<AiFilters>;
  input: FilterAiInputV2;
};

export type FilterAiInputV2 = {
  column: FilterAiColumn;
  country: Scalars['String']['input'];
  hasDigitalSearch?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscribedIndustriesInRequests?: InputMaybe<Scalars['Boolean']['input']>;
  limitByComplianceCodeIndustries?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type FilterAiItemResponseV2 = {
  aiAdvertiserV1: Array<AiFilterItem>;
  aiCategoryV1: Array<AiFilterItem>;
  aiFuelTypeV1: Array<AiFilterItem>;
  aiIndustryV1: Array<AiFilterItem>;
  aiProductV1: Array<AiFilterItem>;
};

export type FilterColumn =
  | 'adType'
  | 'advertiserDomain'
  | 'advertiserName'
  | 'aiAdTypeV1'
  | 'aiAdvertiserV1'
  | 'aiCategoryV1'
  | 'aiIndustryV1'
  | 'aiProductV1'
  | 'brand'
  | 'campaignId'
  | 'category'
  | 'fuelType'
  | 'industry'
  | 'mediaOwner'
  | 'mediaType'
  | 'placementType'
  | 'product'
  | 'publication'
  | 'publicationId'
  | 'publisher'
  | 'region'
  | 'segment'
  | 'status';

export type FilterColumnV2 =
  | 'adType'
  | 'advertiserDomain'
  | 'advertiserName'
  | 'aiAdTypeV1'
  | 'aiAdvertiserV1'
  | 'aiCategoryV1'
  | 'aiIndustryV1'
  | 'aiProductV1'
  | 'brand'
  | 'campaign'
  | 'category'
  | 'changeset'
  | 'fuelType'
  | 'industry'
  | 'mediaOwner'
  | 'mediaType'
  | 'placementType'
  | 'product'
  | 'publication'
  | 'publisher'
  | 'region'
  | 'release'
  | 'segment'
  | 'status';

export type FilterForFilteringFiltersV2 = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  aiAdTypeV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiAdvertiserV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCategoryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiIndustryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiProductV1?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  campaign?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRangeFilter?: InputMaybe<CreativeListDateRangeFilterV2>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaOwner?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  placementType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  publication?: InputMaybe<Array<Scalars['ID']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<CreativeStatusV2>>;
};

export type FilterInputV2 = {
  column: FilterColumnV2;
  country?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type FilterItem = {
  filter: Array<FilterItemFilter>;
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
};

export type FilterItemFilter = {
  column?: Maybe<FilterColumn>;
  value: Scalars['String']['output'];
};

export type FilterItemV2Response = {
  adType?: Maybe<Array<AdTypeV2>>;
  advertiserDomain?: Maybe<Array<AdvertiserDomain>>;
  advertiserName?: Maybe<Array<DummyItem>>;
  brand?: Maybe<Array<BrandV2>>;
  campaign?: Maybe<Array<CampaignV2>>;
  category?: Maybe<Array<CategoryV2>>;
  changeset?: Maybe<Array<Changeset>>;
  industry?: Maybe<Array<IndustryV2>>;
  location?: Maybe<Array<DummyItem>>;
  mediaOwner?: Maybe<Array<MediaOwner>>;
  mediaType?: Maybe<Array<MediaTypeV2>>;
  placementType?: Maybe<Array<PlacementType>>;
  product?: Maybe<Array<ProductV2>>;
  publication?: Maybe<Array<PublicationV2>>;
  publisher?: Maybe<Array<Publisher>>;
  region?: Maybe<Array<RegionV2>>;
  segment?: Maybe<Array<SegmentV2>>;
  status?: Maybe<Array<StatusFilterV2>>;
};

export type FilterOptions = {
  limitResponseByAccess?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<FilterType>;
};

export type FilterQueryV2 = {
  convertNameFiltersToIds?: Maybe<ConvertFiltersOutput>;
  convertNamesToEntities?: Maybe<ConvertNameToEntitiesOutput>;
  filters?: Maybe<FilterResultV2>;
  getEntitiesById: EntitiesById;
};


export type FilterQueryV2ConvertNameFiltersToIdsArgs = {
  input: ConvertFiltersInput;
};


export type FilterQueryV2ConvertNamesToEntitiesArgs = {
  input: ConvertNameToEntitiesInput;
};


export type FilterQueryV2FiltersArgs = {
  filter?: InputMaybe<FilterForFilteringFiltersV2>;
  input: FilterInputV2;
  options?: InputMaybe<FilterOptions>;
};


export type FilterQueryV2GetEntitiesByIdArgs = {
  input: GetEntitiesByIdInput;
};

export type FilterResultV2 = {
  column: FilterColumnV2;
  items: FilterItemV2Response;
  pageInfo: FilterTypeResultPageInfo;
};

export type FilterType =
  | 'creative'
  | 'mediaValue';

export type FilterTypeAiResultPageInfoV2 = {
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  nextOffset?: Maybe<Scalars['Int']['output']>;
};

export type FilterTypeResultPageInfo = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type FirstNonAuSegmentCreateInput = {
  country: Scalars['String']['input'];
  definitionV2: Scalars['JSON']['input'];
  emailAlert: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ForecastDates = {
  forecastCutoff: Scalars['String']['output'];
  forecastCutoffDigital: Scalars['String']['output'];
  maxDate: Scalars['String']['output'];
};

export type GetEntitiesByIdInput = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  campaign?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  changeset?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaOwner?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  publication?: InputMaybe<Array<Scalars['String']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  release?: InputMaybe<Array<Scalars['String']['input']>>;
  segment?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GlobalMediaValueBreakdownColumn =
  | 'adType'
  | 'brand'
  | 'category'
  | 'fuelType'
  | 'industry'
  | 'mediaType'
  | 'product'
  | 'publication'
  | 'publisher'
  | 'region';

export type GlobalMediaValueColumnFilter = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelType?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  publication?: InputMaybe<Array<Scalars['String']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GlobalMediaValueColumnTotal = {
  column: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type GlobalMediaValueComparisonPeriod = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
};

export type GlobalMediaValueCsvResult = {
  csv: Scalars['String']['output'];
};

export type GlobalMediaValueDateRangeFilter = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
  relative?: InputMaybe<GlobalMediaValueRelativeDateRangeFilter>;
  truncateMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalMediaValueExcludeList = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelType?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  publication?: InputMaybe<Array<Scalars['String']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GlobalMediaValueExpenditureReportCell = {
  adType?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  fuelType?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  publication?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type GlobalMediaValueExpenditureReportResult = {
  /** The used to be called "rows', but they're strictly treated as "cells" more than actual rows */
  cells: Array<GlobalMediaValueExpenditureReportCell>;
  columnTotals?: Maybe<Array<GlobalMediaValueColumnTotal>>;
  grandTotal?: Maybe<Scalars['Float']['output']>;
  meta?: Maybe<GlobalMediaValueMeta>;
  pageInfo: GlobalMediaValuePageInfo;
};

export type GlobalMediaValueFilterQueryResult = {
  after?: Maybe<Scalars['String']['output']>;
  items: Array<GlobalMediaValueFilterValue>;
};

export type GlobalMediaValueFilterValue = {
  column: GlobalMediaValueInputColumn;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type GlobalMediaValueInputColumn =
  | 'adType'
  | 'brand'
  | 'category'
  | 'fuelType'
  | 'industry'
  | 'mediaType'
  | 'product'
  | 'publication'
  | 'publisher'
  | 'region';

export type GlobalMediaValueMeta = {
  isTruncated: Scalars['Boolean']['output'];
};

export type GlobalMediaValueOrderByInput = {
  column: Scalars['String']['input'];
  order: OrderByOrders;
};

export type GlobalMediaValuePageInfo = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type GlobalMediaValuePagination = {
  orderBy?: InputMaybe<GlobalMediaValueOrderByInput>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalMediaValuePeriodSelection = {
  comparisonPeriod?: InputMaybe<GlobalMediaValueComparisonPeriod>;
  config?: InputMaybe<GlobalMediaValuePeriodSelectionConfig>;
  reportingPeriod: GlobalMediaValueReportingPeriod;
};

export type GlobalMediaValuePeriodSelectionConfig = {
  comparisonPeriodName?: InputMaybe<Scalars['String']['input']>;
  groupByMonth?: InputMaybe<Scalars['Boolean']['input']>;
  reportingPeriodName?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMediaValueQuery = {
  comparison: GlobalMediaValueReportOutput;
  csv: GlobalMediaValueCsvResult;
  distribution: GlobalMediaValueReportOutput;
  expenditureReport: GlobalMediaValueExpenditureReportResult;
  filterQuery: GlobalMediaValueFilterQueryResult;
  stats: GlobalMediaValueStatsResult;
};


export type GlobalMediaValueQueryComparisonArgs = {
  country: SupportedCountry;
  periodSelection: GlobalMediaValuePeriodSelection;
  rows: Array<GlobalMediaValueRowFilterInput>;
};


export type GlobalMediaValueQueryCsvArgs = {
  columnFilter?: InputMaybe<GlobalMediaValueColumnFilter>;
  columns?: InputMaybe<Array<GlobalMediaValueInputColumn>>;
  country: SupportedCountry;
  csvFileName?: InputMaybe<Scalars['String']['input']>;
  dateRangeFilter?: InputMaybe<GlobalMediaValueDateRangeFilter>;
  excludeList?: InputMaybe<GlobalMediaValueExcludeList>;
  includeDollarFigureForSOVReports?: InputMaybe<Scalars['Boolean']['input']>;
  includePercentage?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<GlobalMediaValuePagination>;
  useCreativeViewerIndustryIds?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GlobalMediaValueQueryDistributionArgs = {
  breakdownColumn: GlobalMediaValueBreakdownColumn;
  country: SupportedCountry;
  dateRangeFilter: GlobalMediaValueDateRangeFilter;
  rows: Array<GlobalMediaValueRowFilterInput>;
};


export type GlobalMediaValueQueryExpenditureReportArgs = {
  columnFilter?: InputMaybe<GlobalMediaValueColumnFilter>;
  columns?: InputMaybe<Array<GlobalMediaValueInputColumn>>;
  country: SupportedCountry;
  dateRangeFilter?: InputMaybe<GlobalMediaValueDateRangeFilter>;
  excludeList?: InputMaybe<GlobalMediaValueExcludeList>;
  includeColumnTotals?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<GlobalMediaValuePagination>;
  useCreativeViewerIndustryIds?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GlobalMediaValueQueryFilterQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  column: GlobalMediaValueInputColumn;
  country: SupportedCountry;
  filter?: InputMaybe<GlobalMediaValueColumnFilter>;
  restrictedItemDisplayType?: InputMaybe<GlobalMediaValueRestrictedtemDisplayType>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type GlobalMediaValueQueryStatsArgs = {
  country: SupportedCountry;
};

export type GlobalMediaValueRelativeDateRangeFilter = {
  includeForecasted: Scalars['Boolean']['input'];
  months: Scalars['Int']['input'];
};

export type GlobalMediaValueReportOutput = {
  columnMeta: Scalars['JSON']['output'];
  rows: Scalars['JSON']['output'];
};

export type GlobalMediaValueReportingPeriod = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
  relative?: InputMaybe<GlobalMediaValueRelativeDateRangeFilter>;
};

export type GlobalMediaValueRestrictedtemDisplayType =
  | 'hidden'
  | 'locked'
  | 'shown';

export type GlobalMediaValueRowFilterInput = {
  filter: GlobalMediaValueColumnFilter;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type GlobalMediaValueStatsResult = {
  latestDate: Scalars['String']['output'];
};

export type GroupByCampaignInput = {
  filters: CreativeListFilterInputV2;
  orderBy: CreativeListOrderByV2;
  pagination?: InputMaybe<GroupByCampaignPaginationInput>;
};

export type GroupByCampaignPaginationInfo = {
  afterKey?: Maybe<Scalars['String']['output']>;
  nextPageMayContainMoreCampaigns: Scalars['Boolean']['output'];
};

export type GroupByCampaignPaginationInput = {
  afterKey?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupByCampaignResult = {
  items: Array<CampaignGroup>;
  paginationInfo?: Maybe<GroupByCampaignPaginationInfo>;
};

export type ICreativeItem = {
  advertiserDomain?: Maybe<Scalars['String']['output']>;
  aiAdTypeV1?: Maybe<Scalars['String']['output']>;
  aiCampaignHeadlineV1?: Maybe<Array<Scalars['String']['output']>>;
  aiDemographicsV1?: Maybe<Array<Demographics>>;
  aiExtractedTextV1?: Maybe<Scalars['String']['output']>;
  aiSummaryInsightsV1?: Maybe<Array<Summary>>;
  aiTagsV1?: Maybe<Array<AiTag>>;
  aiTranscriptionTextV1?: Maybe<Scalars['String']['output']>;
  compliance?: Maybe<Array<ComplianceData>>;
  country?: Maybe<Scalars['String']['output']>;
  creative: Scalars['String']['output'];
  firstAppeared?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastAppeared?: Maybe<Scalars['Date']['output']>;
  mediaOwnerList: Array<MediaOwner>;
  mediaTypeList: Array<MediaTypeV2>;
  placementTypes?: Maybe<Array<Scalars['String']['output']>>;
  publicationList: Array<PublicationV2>;
  publisherList: Array<Publisher>;
  regionList: Array<PublicationV2>;
  status: CreativeStatusV2;
};

export type IncrementDownloadCountInput = {
  id: Scalars['UUID']['input'];
};

export type IndustryV2 = {
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InputColumn =
  | 'adType'
  | 'brand'
  | 'campaignId'
  | 'category'
  | 'industry'
  | 'mediaType'
  | 'product'
  | 'region'
  | 'segment';

export type InviteUserToTeamInput = {
  inviterId: Scalars['String']['input'];
  role: TeamMemberRole;
  teamId: Scalars['UUID']['input'];
  username: Scalars['String']['input'];
};

export type LocationV2 = {
  name: Scalars['String']['output'];
};

export type MediaOwner = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MediaTypeV2 = {
  canonicalName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MediaValueBreakdownColumn =
  | 'adType'
  | 'brand'
  | 'category'
  | 'fuelType'
  | 'industry'
  | 'mediaOwner'
  | 'mediaType'
  | 'product'
  | 'publisher'
  | 'region';

export type MediaValueColumnFilter = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  campaign?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelType?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaOwner?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  segment?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaValueCsvResult = {
  csv: Scalars['String']['output'];
};

export type MediaValueDateRangeFilter = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
  relative?: InputMaybe<MediaValueRelativeDateRangeFilter>;
  truncateMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaValueEntitiesQuery = {
  filterMediaValueEntities: MediaValueFilterResult;
};


export type MediaValueEntitiesQueryFilterMediaValueEntitiesArgs = {
  filter?: InputMaybe<MediaValueFilters>;
  input: MediaValueFilterInput;
};

export type MediaValueExcludeList = {
  adType?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  campaign?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaOwner?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaType?: InputMaybe<Array<Scalars['String']['input']>>;
  product?: InputMaybe<Array<Scalars['String']['input']>>;
  publisher?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaValueFilterColumn =
  | 'aiAdvertiserV1'
  | 'aiCategoryV1'
  | 'aiFuelTypeV1'
  | 'aiIndustryV1'
  | 'aiProductV1';

export type MediaValueFilterInput = {
  column: MediaValueFilterColumn;
  country: Scalars['String']['input'];
  includeSubscribedIndustriesInRequests?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type MediaValueFilterItem = {
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type MediaValueFilterItemResponse = {
  aiAdvertiserV1: Array<MediaValueFilterItem>;
  aiCategoryV1: Array<MediaValueFilterItem>;
  aiFuelTypeV1: Array<MediaValueFilterItem>;
  aiIndustryV1: Array<MediaValueFilterItem>;
  aiProductV1: Array<MediaValueFilterItem>;
};

export type MediaValueFilterPageInfo = {
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  nextOffset?: Maybe<Scalars['Int']['output']>;
};

export type MediaValueFilterResult = {
  column: MediaValueFilterColumn;
  items: MediaValueFilterItemResponse;
  pageInfo?: Maybe<MediaValueFilterPageInfo>;
};

export type MediaValueFilters = {
  aiAdvertiserV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiCategoryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiFuelTypeV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiIndustryV1?: InputMaybe<Array<Scalars['String']['input']>>;
  aiProductV1?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaValueInputColumn =
  | 'adType'
  | 'brand'
  | 'campaign'
  | 'category'
  | 'fuelType'
  | 'industry'
  | 'mediaOwner'
  | 'mediaType'
  | 'product'
  | 'publication'
  | 'publisher'
  | 'region'
  | 'segment';

export type MediaValueLabels = {
  adType: Array<AdTypeV2>;
  brand: Array<BrandV2>;
  campaign: Array<CampaignV2>;
  category: Array<CategoryV2>;
  industry: Array<IndustryV2>;
  mediaOwner: Array<MediaOwner>;
  mediaType: Array<MediaTypeV2>;
  product: Array<ProductV2>;
  publication: Array<PublicationV2>;
  publisher: Array<Publisher>;
  region: Array<RegionV2>;
  segment: Array<Segment>;
};

export type MediaValueLabelsV3 = {
  segment: Array<Segment>;
};

export type MediaValueMeta = {
  isTruncated: Scalars['Boolean']['output'];
};

export type MediaValueOrderByInput = {
  column: Scalars['String']['input'];
  order: OrderByOrders;
};

export type MediaValuePageInfo = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type MediaValuePagination = {
  orderBy?: InputMaybe<MediaValueOrderByInput>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaValueQuery = {
  comparisonV3: MediaValueReportOutput;
  csvV3: MediaValueCsvResult;
  distributionV3: MediaValueReportOutput;
  getForecastDates: ForecastDates;
  rowsV3: MediaValueResultV3;
};


export type MediaValueQueryComparisonV3Args = {
  periodSelection: PeriodSelection;
  rows: Array<MediaValueRowFilterInput>;
};


export type MediaValueQueryCsvV3Args = {
  changesetId?: InputMaybe<Scalars['Int']['input']>;
  columnFilter?: InputMaybe<MediaValueColumnFilter>;
  columns?: InputMaybe<Array<MediaValueInputColumn>>;
  csvFileName?: InputMaybe<Scalars['String']['input']>;
  dateRangeFilter?: InputMaybe<MediaValueDateRangeFilter>;
  excludeList?: InputMaybe<MediaValueExcludeList>;
  includeDollarFigureForSOVReports?: InputMaybe<Scalars['Boolean']['input']>;
  includePercentage?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<MediaValuePagination>;
};


export type MediaValueQueryDistributionV3Args = {
  breakdownColumn: MediaValueBreakdownColumn;
  dateRangeFilter: MediaValueDateRangeFilter;
  rows: Array<MediaValueRowFilterInput>;
};


export type MediaValueQueryGetForecastDatesArgs = {
  queryOpensearch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaValueQueryRowsV3Args = {
  changesetId?: InputMaybe<Scalars['Int']['input']>;
  columnFilter?: InputMaybe<MediaValueColumnFilter>;
  columns?: InputMaybe<Array<MediaValueInputColumn>>;
  dateRangeFilter?: InputMaybe<MediaValueDateRangeFilter>;
  excludeList?: InputMaybe<MediaValueExcludeList>;
  pagination?: InputMaybe<MediaValuePagination>;
};

export type MediaValueRelativeDateRangeFilter = {
  includeForecasted: Scalars['Boolean']['input'];
  months: Scalars['Int']['input'];
};

export type MediaValueReportOutput = {
  columnMeta: Scalars['JSON']['output'];
  rows: Scalars['JSON']['output'];
};

export type MediaValueResultV3 = {
  columnTotals: Array<ColumnTotal>;
  grandTotal: Scalars['Float']['output'];
  labels: MediaValueLabelsV3;
  meta?: Maybe<MediaValueMeta>;
  pageInfo: MediaValuePageInfo;
  rows: Array<MediaValueRow>;
};

export type MediaValueRow = {
  adType?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  fuelType?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  mediaOwner?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  publication?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type MediaValueRowFilterInput = {
  filter: MediaValueColumnFilter;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type Mutation = {
  _?: Maybe<Scalars['String']['output']>;
  compliance?: Maybe<ComplianceMutations>;
  pdfRenderer?: Maybe<PdfRendererMutation>;
  report?: Maybe<ReportMutation>;
  reportV2?: Maybe<ReportV2Mutation>;
  segment?: Maybe<SegmentMutation>;
  segmentV2?: Maybe<SegmentV2Mutation>;
  team?: Maybe<TeamMutation>;
  tracking?: Maybe<TrackingMutation>;
  user?: Maybe<UserMutation>;
};

export type OnboardingSearchInput = {
  country?: InputMaybe<SupportedCountry>;
  includeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  useMediaValueV3?: InputMaybe<Scalars['Boolean']['input']>;
  useOpenSearch?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderByOrders =
  | 'ASC'
  | 'DESC';

export type OrderDirection =
  | 'ASC'
  | 'DESC';

export type PageInfo = {
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type PartialIndustry = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PdfCreativeInput = {
  appUrl: Scalars['String']['input'];
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  filter: Scalars['String']['input'];
  printConfig?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};

export type PdfRendererDownloadLink = {
  downloadLink: Scalars['String']['output'];
};

export type PdfRendererMutation = {
  pdfCreative: PdfRendererDownloadLink;
  pdfReportCreate: PdfRendererDownloadLink;
};


export type PdfRendererMutationPdfCreativeArgs = {
  input: PdfCreativeInput;
};


export type PdfRendererMutationPdfReportCreateArgs = {
  input: PdfReportItemInput;
};

export type PdfReportItemInput = {
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  printConfig?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['UUID']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PeriodSelection = {
  comparisonPeriod?: InputMaybe<ComparisonPeriod>;
  config?: InputMaybe<PeriodSelectionConfig>;
  reportingPeriod: ReportingPeriod;
};

export type PeriodSelectionConfig = {
  comparisonPeriodName?: InputMaybe<Scalars['String']['input']>;
  groupByMonth?: InputMaybe<Scalars['Boolean']['input']>;
  reportingPeriodName?: InputMaybe<Scalars['String']['input']>;
};

export type PlacementType = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProductNameInput = {
  brand: Scalars['String']['input'];
  product: Scalars['String']['input'];
};

export type ProductV2 = {
  brand?: Maybe<BrandV2>;
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PublicCreativeItemV2 = {
  adType?: Maybe<AdTypeV2>;
  advertiserDomain?: Maybe<Scalars['String']['output']>;
  advertiserName?: Maybe<Scalars['String']['output']>;
  aiAdTypeV1?: Maybe<Scalars['String']['output']>;
  aiAdvertisersV1?: Maybe<Array<Scalars['String']['output']>>;
  aiCategoriesV1?: Maybe<Array<Scalars['String']['output']>>;
  aiDemographicsV1?: Maybe<Array<Demographics>>;
  aiExtractedTextV1?: Maybe<Scalars['String']['output']>;
  aiIndustriesV1?: Maybe<Array<Scalars['String']['output']>>;
  aiProductsV1?: Maybe<Array<Scalars['String']['output']>>;
  aiSummaryInsightsV1?: Maybe<Array<Summary>>;
  aiTagsV1?: Maybe<Array<AiTag>>;
  aiTranscriptionTextV1?: Maybe<Scalars['String']['output']>;
  brandList: Array<BrandV2>;
  categoryList: Array<CategoryV2>;
  compliance?: Maybe<Array<ComplianceData>>;
  country?: Maybe<Scalars['String']['output']>;
  creative: Scalars['String']['output'];
  firstAppeared?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  industryList: Array<IndustryV2>;
  lastAppeared?: Maybe<Scalars['Date']['output']>;
  mediaOwnerList: Array<MediaOwner>;
  mediaTypeList: Array<MediaTypeV2>;
  placementTypes: Array<Scalars['String']['output']>;
  productList: Array<ProductV2>;
  publicationList: Array<PublicationV2>;
  publisherList: Array<Publisher>;
  regionList: Array<RegionV2>;
  status: CreativeStatusV2;
};

export type PublicationV2 = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Publisher = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  _?: Maybe<Scalars['String']['output']>;
  aiEntities?: Maybe<FilterAiEntitiesQuery>;
  changeset?: Maybe<ChangesetQuery>;
  compliance?: Maybe<ComplianceQuery>;
  creativeV2?: Maybe<CreativeQueryV2>;
  dashboardV3?: Maybe<DashboardQueryV3>;
  filterV2?: Maybe<FilterQueryV2>;
  globalMediaValue: GlobalMediaValueQuery;
  mediaValue: MediaValueQuery;
  mediaValueEntities?: Maybe<MediaValueEntitiesQuery>;
  report?: Maybe<ReportQuery>;
  reportV2?: Maybe<ReportV2Query>;
  reportV3?: Maybe<ReportV3Query>;
  searchV2?: Maybe<SearchV2Query>;
  segment?: Maybe<SegmentQuery>;
  segmentV2?: Maybe<SegmentV2Query>;
  team?: Maybe<TeamQuery>;
  user?: Maybe<UserQuery>;
  viewer?: Maybe<ViewerQuery>;
};


export type QueryViewerArgs = {
  options?: InputMaybe<ViewerQueryOptions>;
};

export type RegionV2 = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RemoveTeamInput = {
  teamId: Scalars['UUID']['input'];
};

export type RemoveTeamInviteInput = {
  inviteId: Scalars['UUID']['input'];
};

export type RemoveTeamMemberInput = {
  teamId: Scalars['UUID']['input'];
  userId: Scalars['String']['input'];
};

export type Report = ReportSchema & {
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  items: Array<ReportItem>;
  name: Scalars['String']['output'];
  shared: Scalars['Boolean']['output'];
  sharing: ReportSharing;
  status: Scalars['String']['output'];
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<ReportUser>;
};

export type ReportChangeOwnershipInput = {
  id: Scalars['UUID']['input'];
  newTeamId: Scalars['UUID']['input'];
  newUserId: Scalars['String']['input'];
};

export type ReportCreateInput = {
  country: Scalars['String']['input'];
  iconColor: Scalars['String']['input'];
  iconName: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportItem = {
  createdAt: Scalars['DateTime']['output'];
  definition: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  teamId: Scalars['UUID']['output'];
  type: ReportItemType;
  updateAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ReportItemCreateInput = {
  definition: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reportId: Scalars['UUID']['input'];
  type: ReportItemType;
};

export type ReportItemGetInput = {
  id: Scalars['UUID']['input'];
  reportId: Scalars['UUID']['input'];
};

export type ReportItemRemoveInput = {
  id: Scalars['UUID']['input'];
  reportId: Scalars['UUID']['input'];
};

export type ReportItemType =
  | 'AdvertisingCreative'
  | 'Comparison'
  | 'Distribution'
  | 'Embed'
  | 'MediaValue';

export type ReportItemUpdateInput = {
  definition: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  reportId: Scalars['UUID']['input'];
  type: ReportItemType;
};

export type ReportItemV2 = {
  createdAt: Scalars['DateTime']['output'];
  definition?: Maybe<Scalars['JSON']['output']>;
  definitionV2: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  teamId: Scalars['UUID']['output'];
  type: ReportItemType;
  updateAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ReportItemV2CreateInput = {
  definitionV2: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reportId: Scalars['UUID']['input'];
  type: ReportItemType;
};

export type ReportItemV2UpdateInput = {
  definitionV2: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  reportId: Scalars['UUID']['input'];
  type: ReportItemType;
};

export type ReportListFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type ReportListInput = {
  country: Scalars['String']['input'];
  filter?: InputMaybe<ReportListFilter>;
  orderBy?: InputMaybe<ReportListOrderBy>;
  pagination?: InputMaybe<ReportListPagination>;
};

export type ReportListItem = ReportSchema & {
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  shared: Scalars['Boolean']['output'];
  sharing: ReportSharing;
  status: Scalars['String']['output'];
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<ReportUser>;
};

export type ReportListOrderBy = {
  field: ReportListOrderField;
  order: OrderByOrders;
};

export type ReportListOrderField =
  | 'fullName'
  | 'name'
  | 'teamName'
  | 'updatedAt';

export type ReportListPagination = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type ReportListPaginationResult = {
  count: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
};

export type ReportListResult = {
  items: Array<ReportListItem>;
  pagination: ReportListPaginationResult;
};

export type ReportMutation = {
  reportCreate: Report;
  reportDuplicate?: Maybe<Report>;
  reportItemCreate: ReportItem;
  reportItemRemove: Scalars['Boolean']['output'];
  reportItemUpdate?: Maybe<ReportItem>;
  reportRemove: Scalars['Boolean']['output'];
  reportUpdate?: Maybe<Report>;
};


export type ReportMutationReportCreateArgs = {
  input: ReportCreateInput;
};


export type ReportMutationReportDuplicateArgs = {
  id: Scalars['UUID']['input'];
};


export type ReportMutationReportItemCreateArgs = {
  input: ReportItemCreateInput;
};


export type ReportMutationReportItemRemoveArgs = {
  input: ReportItemRemoveInput;
};


export type ReportMutationReportItemUpdateArgs = {
  input: ReportItemUpdateInput;
};


export type ReportMutationReportRemoveArgs = {
  id: Scalars['UUID']['input'];
};


export type ReportMutationReportUpdateArgs = {
  input: ReportUpdateInput;
};

export type ReportQuery = {
  report: Report;
  reportItem: ReportItem;
  reportList: Array<ReportListItem>;
};


export type ReportQueryReportArgs = {
  id: Scalars['UUID']['input'];
};


export type ReportQueryReportItemArgs = {
  input: ReportItemGetInput;
};

export type ReportSchema = {
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  shared: Scalars['Boolean']['output'];
  sharing: ReportSharing;
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<ReportUser>;
};

export type ReportSearchInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ReportShareManyInput = {
  ids: Array<Scalars['UUID']['input']>;
  sharedStatus: SharedStatus;
  userIdsWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReportSharing = {
  status: SharedStatus;
  usersWithAccess: Array<SharedUser>;
};

export type ReportUpdateInput = {
  description: Scalars['String']['input'];
  iconColor: Scalars['String']['input'];
  iconName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  itemsSort?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name: Scalars['String']['input'];
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  sharedStatus?: InputMaybe<SharedStatus>;
  userIdsWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReportUpdateManyInput = {
  reports: Array<ReportUpdateInput>;
};

export type ReportUser = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReportV2 = ReportSchema & {
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  items: Array<ReportItemV2>;
  name: Scalars['String']['output'];
  shared: Scalars['Boolean']['output'];
  sharing: ReportSharing;
  status: Scalars['String']['output'];
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<ReportUser>;
};

export type ReportV2Mutation = {
  reportChangeOwnership: ChangeOwnershipData;
  reportCreate: ReportV2;
  reportDuplicate?: Maybe<ReportV2>;
  reportItemCreate: ReportItemV2;
  reportItemRemove: Scalars['Boolean']['output'];
  reportItemUpdate: ReportItemV2;
  reportRemove: Scalars['Boolean']['output'];
  reportRemoveMany: Array<ReportListItem>;
  reportShareMany: Array<ReportListItem>;
  reportUpdate?: Maybe<ReportV2>;
};


export type ReportV2MutationReportChangeOwnershipArgs = {
  input: ReportChangeOwnershipInput;
};


export type ReportV2MutationReportCreateArgs = {
  input: ReportCreateInput;
};


export type ReportV2MutationReportDuplicateArgs = {
  id: Scalars['UUID']['input'];
};


export type ReportV2MutationReportItemCreateArgs = {
  input: ReportItemV2CreateInput;
};


export type ReportV2MutationReportItemRemoveArgs = {
  input: ReportItemRemoveInput;
};


export type ReportV2MutationReportItemUpdateArgs = {
  input: ReportItemV2UpdateInput;
};


export type ReportV2MutationReportRemoveArgs = {
  id: Scalars['UUID']['input'];
};


export type ReportV2MutationReportRemoveManyArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type ReportV2MutationReportShareManyArgs = {
  input: ReportShareManyInput;
};


export type ReportV2MutationReportUpdateArgs = {
  input: ReportUpdateInput;
};

export type ReportV2Query = {
  report: ReportV2;
  reportItem: ReportItemV2;
  reportList: Array<ReportListItem>;
  reportSearch: Array<ReportListItem>;
};


export type ReportV2QueryReportArgs = {
  id: Scalars['UUID']['input'];
};


export type ReportV2QueryReportItemArgs = {
  input: ReportItemGetInput;
};


export type ReportV2QueryReportListArgs = {
  input: ReportListInput;
};


export type ReportV2QueryReportSearchArgs = {
  input: ReportSearchInput;
};

export type ReportV3Query = {
  reportList: ReportListResult;
};


export type ReportV3QueryReportListArgs = {
  input: ReportListInput;
};

export type ReportingPeriod = {
  absolute?: InputMaybe<AbsoluteDateRangeFilter>;
  relative?: InputMaybe<MediaValueRelativeDateRangeFilter>;
};

export type ResendTeamInviteInput = {
  inviteId: Scalars['UUID']['input'];
};

export type ResetDownloadCountInput = {
  id: Scalars['UUID']['input'];
};

export type ResultColumn =
  | 'adType'
  | 'brand'
  | 'campaignId'
  | 'category'
  | 'creativeTheme'
  | 'industry'
  | 'mediaType'
  | 'product'
  | 'region'
  | 'segment';

export type ResultTypeV2 =
  | 'brand'
  | 'category'
  | 'industry'
  | 'product';

export type SearchInputOrderBy =
  | 'alphabetical'
  | 'spend';

export type SearchInputOrderDirection =
  | 'ASC'
  | 'DESC';

export type SearchInputV2 = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<SupportedCountry>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  limitToViewerIndustries?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<SearchInputOrderBy>;
  orderDirection?: InputMaybe<SearchInputOrderDirection>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  type: ResultTypeV2;
};

export type SearchItemV2 = {
  brand?: Maybe<BrandV2>;
  hasAccess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  industries?: Maybe<Array<PartialIndustry>>;
  name: Scalars['String']['output'];
  type: ResultTypeV2;
};

export type SearchPageV2 = {
  items: Array<SearchItemV2>;
  pageInfo: PageInfo;
};

export type SearchV2Query = {
  onboardingSearch: SearchPageV2;
  search: SearchPageV2;
  uniqueIndustryGroupsSearch: UniqueIndustryGroupsSearchResult;
};


export type SearchV2QueryOnboardingSearchArgs = {
  search: OnboardingSearchInput;
};


export type SearchV2QuerySearchArgs = {
  search?: InputMaybe<SearchInputV2>;
};


export type SearchV2QueryUniqueIndustryGroupsSearchArgs = {
  search?: InputMaybe<UniqueIndustryGroupsSearchInput>;
};

export type Segment = SegmentSchema & {
  author: SharedUser;
  color: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  definition: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sharing: SegmentSharing;
  status?: Maybe<DeletedStatus>;
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SegmentCreateInput = {
  color: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sharedStatus?: InputMaybe<SharedStatus>;
  userIdsWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SegmentListItem = {
  data: Array<Maybe<Segment>>;
};

export type SegmentListOptions = {
  country?: InputMaybe<Scalars['String']['input']>;
  idList?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoreSharing?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  requestFullPrimitives?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SegmentMutation = {
  segmentCreate: Segment;
  segmentRemove?: Maybe<Scalars['Boolean']['output']>;
  segmentUpdate?: Maybe<Segment>;
};


export type SegmentMutationSegmentCreateArgs = {
  input: SegmentCreateInput;
};


export type SegmentMutationSegmentRemoveArgs = {
  id: Scalars['UUID']['input'];
};


export type SegmentMutationSegmentUpdateArgs = {
  input: SegmentUpdateInput;
};

export type SegmentQuery = {
  segment: Segment;
  segmentList: SegmentListItem;
};


export type SegmentQuerySegmentArgs = {
  id: Scalars['UUID']['input'];
  ignoreSharing?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type SegmentQuerySegmentListArgs = {
  input?: InputMaybe<SegmentListOptions>;
};

export type SegmentSchema = {
  author?: Maybe<SharedUser>;
  color: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  definition?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sharing: SegmentSharing;
  status?: Maybe<DeletedStatus>;
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SegmentSearchInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentSharing = {
  status: SharedStatus;
  usersWithAccess: Array<SharedUser>;
};

export type SegmentUpdateInput = {
  color: Scalars['String']['input'];
  definition: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  sharedStatus?: InputMaybe<SharedStatus>;
  userIdsWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SegmentV2 = SegmentSchema & {
  author: SharedUser;
  color: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  definition?: Maybe<Scalars['JSON']['output']>;
  definitionV2: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emailAlert: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sharing: SegmentSharing;
  status?: Maybe<DeletedStatus>;
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SegmentV2ChangeOwnership = {
  id: Scalars['UUID']['input'];
  newTeamId: Scalars['UUID']['input'];
  newUserId: Scalars['String']['input'];
};

export type SegmentV2CreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  definitionV2?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailAlert?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sharedStatus?: InputMaybe<SharedStatus>;
  userIdsWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SegmentV2ListItem = {
  author: SharedUser;
  color: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  definitionV2?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailAlert?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sharing: SegmentSharing;
  status?: Maybe<DeletedStatus>;
  teamId: Scalars['UUID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SegmentV2ListItems = {
  data: Array<Maybe<SegmentV2ListItem>>;
};

export type SegmentV2Mutation = {
  creativeEmailSegmentUpdate?: Maybe<SegmentV2>;
  firstNonAuSegmentCreate?: Maybe<SegmentV2>;
  nzUnsubscribe?: Maybe<Scalars['Boolean']['output']>;
  segmentChangeOwnership?: Maybe<SegmentV2>;
  segmentCreate: SegmentV2;
  segmentRemove?: Maybe<Scalars['Boolean']['output']>;
  segmentRemoveMany: SegmentV2ListItems;
  segmentShareMany: SegmentV2ListItems;
  segmentUpdate?: Maybe<SegmentV2>;
};


export type SegmentV2MutationCreativeEmailSegmentUpdateArgs = {
  input: CreativeEmailSegmentUpdateInput;
};


export type SegmentV2MutationFirstNonAuSegmentCreateArgs = {
  input: FirstNonAuSegmentCreateInput;
};


export type SegmentV2MutationNzUnsubscribeArgs = {
  teamId: Scalars['UUID']['input'];
};


export type SegmentV2MutationSegmentChangeOwnershipArgs = {
  input: SegmentV2ChangeOwnership;
};


export type SegmentV2MutationSegmentCreateArgs = {
  input: SegmentV2CreateInput;
};


export type SegmentV2MutationSegmentRemoveArgs = {
  id: Scalars['UUID']['input'];
};


export type SegmentV2MutationSegmentRemoveManyArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type SegmentV2MutationSegmentShareManyArgs = {
  input: SegmentV2ShareManyInput;
};


export type SegmentV2MutationSegmentUpdateArgs = {
  input: SegmentV2UpdateInput;
};

export type SegmentV2Query = {
  creativeEmailSegment?: Maybe<SegmentV2>;
  segment: SegmentV2;
  segmentList: SegmentV2ListItems;
  segmentSearch: SegmentV2ListItems;
};


export type SegmentV2QueryCreativeEmailSegmentArgs = {
  input?: InputMaybe<CreativeEmailSegmentInput>;
};


export type SegmentV2QuerySegmentArgs = {
  id: Scalars['UUID']['input'];
  ignoreSharing?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentV2QuerySegmentListArgs = {
  input?: InputMaybe<SegmentListOptions>;
};


export type SegmentV2QuerySegmentSearchArgs = {
  input: SegmentSearchInput;
};

export type SegmentV2ShareManyInput = {
  ids: Array<Scalars['UUID']['input']>;
  sharedStatus: SharedStatus;
  userIdsWithAccess: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SegmentV2UpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  definitionV2: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emailAlert?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  sharedStatus?: InputMaybe<SharedStatus>;
  userIdsWithAccess?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ShallowReportItem = {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  teamId: Scalars['UUID']['output'];
  type: ReportItemType;
  updateAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type SharedStatus =
  | 'private'
  | 'specificTeamMembers'
  | 'wholeTeam';

export type SharedUser = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StatusFilterV2 = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Summary = {
  summary150?: Maybe<Scalars['String']['output']>;
  summary300?: Maybe<Scalars['String']['output']>;
};

export type SupportedCountry =
  | 'AU'
  | 'NZ';

export type Team = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  invites: Array<UserInvite>;
  members: Array<TeamMember>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<TeamProduct>>>;
  status?: Maybe<TeamStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TeamInvitesArgs = {
  status: Array<UserInviteStatus>;
};

export type TeamAdminProducts =
  | 'DataEntry'
  | 'TeamAdmin'
  | 'Termatico';

export type TeamMember = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role: TeamMemberRole;
  status?: Maybe<TeamMemberStatus>;
  team?: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type TeamMemberRole =
  | 'MEMBER'
  | 'OWNER';

export type TeamMemberStatus =
  | 'DELETED';

export type TeamMutation = {
  teamAddNzTrial: Team;
  teamAddUser?: Maybe<TeamMember>;
  teamCreateWithInvite?: Maybe<Team>;
  teamIncrementDownloadCount?: Maybe<Team>;
  teamInviteUser?: Maybe<UserInvite>;
  teamRemove: Scalars['Boolean']['output'];
  teamRemoveInvite: Scalars['Boolean']['output'];
  teamRemoveUser: Scalars['Boolean']['output'];
  teamResendInvite: Scalars['Boolean']['output'];
  teamResetDownloadCount?: Maybe<Team>;
  teamUpdate?: Maybe<Team>;
  teamUpdateProducts?: Maybe<Array<Maybe<TeamProduct>>>;
  teamUpdateTrialIndustryGroup: Team;
  teamUpdateUser?: Maybe<TeamMember>;
};


export type TeamMutationTeamAddNzTrialArgs = {
  mutation: AddNzTrialInput;
};


export type TeamMutationTeamAddUserArgs = {
  mutation: AddUserToTeamInput;
};


export type TeamMutationTeamCreateWithInviteArgs = {
  mutation: CreateTeamWithInviteInput;
};


export type TeamMutationTeamIncrementDownloadCountArgs = {
  mutation: IncrementDownloadCountInput;
};


export type TeamMutationTeamInviteUserArgs = {
  mutation: InviteUserToTeamInput;
};


export type TeamMutationTeamRemoveArgs = {
  mutation: RemoveTeamInput;
};


export type TeamMutationTeamRemoveInviteArgs = {
  mutation: RemoveTeamInviteInput;
};


export type TeamMutationTeamRemoveUserArgs = {
  mutation: RemoveTeamMemberInput;
};


export type TeamMutationTeamResendInviteArgs = {
  mutation: ResendTeamInviteInput;
};


export type TeamMutationTeamResetDownloadCountArgs = {
  mutation: ResetDownloadCountInput;
};


export type TeamMutationTeamUpdateArgs = {
  mutation: UpdateTeamInput;
};


export type TeamMutationTeamUpdateProductsArgs = {
  mutation: UpdateTeamProductInput;
};


export type TeamMutationTeamUpdateTrialIndustryGroupArgs = {
  mutation: UpdateTeamIndustryGroupInput;
};


export type TeamMutationTeamUpdateUserArgs = {
  mutation: UpdateTeamMemberInput;
};

export type TeamProduct = {
  compliance?: Maybe<ComplianceCountryCodesMapType>;
  country?: Maybe<Scalars['String']['output']>;
  hasSelectedIndustries?: Maybe<Scalars['Boolean']['output']>;
  industries?: Maybe<Array<Scalars['String']['output']>>;
  industryIds?: Maybe<Array<Scalars['String']['output']>>;
  mediaTypeIds?: Maybe<Array<Scalars['String']['output']>>;
  mediaTypes?: Maybe<Array<Scalars['String']['output']>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  product: Scalars['String']['output'];
  status?: Maybe<TeamProductStatus>;
};

export type TeamProductInput = {
  compliance?: InputMaybe<ComplianceCountryCodesMapInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mediaTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  product: TeamProductType;
  status: TeamProductStatus;
};

export type TeamProductStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'TRIALING';

export type TeamProductStatusFilter =
  | 'ACTIVE'
  | 'ADMIN'
  | 'ALL'
  | 'INACTIVE'
  | 'TRIALING';

export type TeamProductStatuses =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'TRIALING';

export type TeamProductType =
  | 'AdvertisingCreative'
  | 'Compliance'
  | 'DataEntry'
  | 'MediaValue'
  | 'TeamAdmin'
  | 'Termatico';

export type TeamQuery = {
  team: Team;
  teamList: Array<Team>;
};


export type TeamQueryTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type TeamQueryTeamListArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  industryList?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TeamProductStatusFilter>;
};

export type TeamStatus =
  | 'DELETED';

export type TrackingFormField = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TrackingMutation = {
  submitHubspotForm?: Maybe<Scalars['Boolean']['output']>;
  submitInternationalTeamOnboardedForm?: Maybe<Scalars['Boolean']['output']>;
  submitUserCreatedAccountForm?: Maybe<Scalars['Boolean']['output']>;
};


export type TrackingMutationSubmitHubspotFormArgs = {
  formId: Scalars['String']['input'];
  formInput: Array<TrackingFormField>;
};


export type TrackingMutationSubmitInternationalTeamOnboardedFormArgs = {
  country: Scalars['String']['input'];
};


export type TrackingMutationSubmitUserCreatedAccountFormArgs = {
  country: SupportedCountry;
};

export type UniqueIndustryGroupsSearchInput = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type UniqueIndustryGroupsSearchResult = {
  items: Array<Scalars['String']['output']>;
};

export type UpdateTeamIndustryGroupInput = {
  industryGroup: Scalars['String']['input'];
  teamId: Scalars['UUID']['input'];
};

export type UpdateTeamInput = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTeamMemberInput = {
  role: TeamMemberRole;
  teamId: Scalars['UUID']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateTeamProductInput = {
  teamId: Scalars['UUID']['input'];
  teamProducts: Array<TeamProductInput>;
};

export type User = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  memberships: Array<TeamMember>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  productMap?: Maybe<UserProductMap>;
  products: Array<UserProduct>;
  status?: Maybe<UserStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UserInvite = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  inviter?: Maybe<User>;
  role: TeamMemberRole;
  status: UserInviteStatus;
  team?: Maybe<Team>;
  username: Scalars['String']['output'];
};

export type UserInviteStatus =
  | 'ACCEPTED'
  | 'AUTO_ACCEPTED'
  | 'DELETED'
  | 'PENDING';

export type UserListFilter = {
  adminProduct?: InputMaybe<TeamAdminProducts>;
  australianCreative?: InputMaybe<TeamProductStatuses>;
  australianMediaValue?: InputMaybe<TeamProductStatuses>;
  newZealandCreative?: InputMaybe<TeamProductStatuses>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type UserListOrderBy = {
  direction?: InputMaybe<UserListOrderByDirection>;
  field?: InputMaybe<UserListOrderByField>;
};

export type UserListOrderByDirection =
  | 'ASC'
  | 'DESC';

export type UserListOrderByField =
  | 'createdAt'
  | 'firstname'
  | 'lastname'
  | 'updatedAt'
  | 'username';

export type UserListPagination = {
  count?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type UserMutation = {
  userUpdate?: Maybe<User>;
  userUpdateSessionMetadata?: Maybe<User>;
};


export type UserMutationUserUpdateArgs = {
  mutation: UserUpdateInput;
};


export type UserMutationUserUpdateSessionMetadataArgs = {
  mutation: UserUpdateSessionMetadataInput;
};

export type UserOnboardingInfo = {
  isAustraliaOnboarded: Scalars['Boolean']['output'];
  isNewZealandOnboarded?: Maybe<Scalars['Boolean']['output']>;
};

export type UserProduct = {
  product: UserProductType;
  status: Scalars['String']['output'];
};

export type UserProductBigdatrPrototype = {
  product: UserProductBigdatrPrototypeType;
  status: UserProductBigdatrPrototypeStatus;
};

export type UserProductBigdatrPrototypeStatus =
  | 'ACTIVE'
  | 'DELETED';

export type UserProductBigdatrPrototypeType =
  | 'BigdatrPrototype';

export type UserProductMap = {
  BigdatrPrototype?: Maybe<UserProductBigdatrPrototype>;
};

export type UserProductType =
  | 'BigdatrPrototype';

export type UserQuery = {
  user: User;
  userList: Array<User>;
};


export type UserQueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type UserQueryUserListArgs = {
  filter?: InputMaybe<UserListFilter>;
  orderBy?: InputMaybe<UserListOrderBy>;
  pagination?: InputMaybe<UserListPagination>;
};

export type UserStatus = {
  adminProducts?: Maybe<Array<Maybe<TeamAdminProducts>>>;
  australianCreative: TeamProductStatuses;
  australianMediaValue: TeamProductStatuses;
  newZealandCreative: TeamProductStatuses;
};

export type UserUpdateInput = {
  firstname?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['Int']['input']>;
};

export type UserUpdateSessionMetadataInput = {
  id: Scalars['String']['input'];
  sessionMetadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type ViewerQuery = {
  id: Scalars['String']['output'];
  teams: Array<ViewerTeam>;
  user: ViewerUser;
  userOnboardingInfo: UserOnboardingInfo;
};

export type ViewerQueryOptions = {
  getForecastDatesFromOS?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewerTeam = {
  downloadCount?: Maybe<Scalars['Int']['output']>;
  hasTrialTeamName?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<TeamProduct>;
  requestedNzTrial?: Maybe<Scalars['Boolean']['output']>;
  role: TeamMemberRole;
  trialExpired?: Maybe<Scalars['Boolean']['output']>;
};

export type ViewerUser = {
  createdAt: Scalars['DateTime']['output'];
  firstname: Scalars['String']['output'];
  hasDataIngestAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  registrationStatus?: Maybe<Scalars['String']['output']>;
  sessionMetadata?: Maybe<Scalars['JSON']['output']>;
  tier?: Maybe<Scalars['Int']['output']>;
  username: Scalars['String']['output'];
};

export type FollowedBrandsQueryVariables = Exact<{
  input: DashboardQueryV3Input;
}>;


export type FollowedBrandsQuery = { dashboardV3?: { followedBrands?: { brands?: Array<{ mediaValue?: { previousPeriodTotal?: number | null, currentPeriodTotal?: number | null, change?: number | null, hasAccess?: boolean | null, currentPeriod?: Array<{ month?: string | null, spend?: number | null } | null> | null, previousPeriod?: Array<{ month?: string | null, spend?: number | null } | null> | null } | null, creatives?: Array<{ id: string, creative: string, firstAppeared?: string | null, lastAppeared?: string | null, status: CreativeStatusV2, adType?: { id: string, name: string, canonicalName: string } | null, categoryList: Array<{ id: string, name: string }>, mediaTypeList: Array<{ id: string, name: string, canonicalName: string }>, mediaOwnerList: Array<{ id: string, name: string }>, publicationList: Array<{ id: string, name: string }>, publisherList: Array<{ id: string, name: string }>, regionList: Array<{ id: string, name: string }>, productList: Array<{ id: string, name: string, brand?: { id: string, name: string } | null }>, brandList: Array<{ id: string, name: string }>, industryList: Array<{ id: string, name: string }> } | null> | null, brand?: { name: string, id: string } | null }> | null, paginationInfo?: { currentPage?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null } | null } | null } | null };

export type TopBrandsQueryVariables = Exact<{
  input: DashboardQueryV3Input;
}>;


export type TopBrandsQuery = { dashboardV3?: { topBrands?: { brands?: Array<{ mediaValue?: { previousPeriodTotal?: number | null, currentPeriodTotal?: number | null, change?: number | null, hasAccess?: boolean | null, currentPeriod?: Array<{ month?: string | null, spend?: number | null } | null> | null, previousPeriod?: Array<{ month?: string | null, spend?: number | null } | null> | null } | null, creatives?: Array<{ id: string, creative: string, firstAppeared?: string | null, lastAppeared?: string | null, status: CreativeStatusV2, adType?: { id: string, name: string, canonicalName: string } | null, categoryList: Array<{ id: string, name: string }>, mediaTypeList: Array<{ id: string, name: string, canonicalName: string }>, mediaOwnerList: Array<{ id: string, name: string }>, publicationList: Array<{ id: string, name: string }>, publisherList: Array<{ id: string, name: string }>, regionList: Array<{ id: string, name: string }>, productList: Array<{ id: string, name: string, brand?: { id: string, name: string } | null }>, brandList: Array<{ id: string, name: string }>, industryList: Array<{ id: string, name: string }> } | null> | null, brand?: { name: string, id: string } | null }> | null, paginationInfo?: { currentPage?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null } | null } | null } | null };

export type ComplianceCreativeListV2QueryVariables = Exact<{
  input: ComplianceCreativeListV2QueryInput;
}>;


export type ComplianceCreativeListV2Query = { compliance?: { creativeListV2: { paginationInfo: { nextPageCursor?: Array<string> | null, mightHaveNextPage: boolean, receivedCreatives: number }, items: Array<{ progressStatus?: ComplianceCreativeProgressStatus | null, id: string, creative: string, firstAppeared?: string | null, lastAppeared?: string | null, status: CreativeStatusV2, country?: string | null, placementTypes?: Array<string> | null, advertiserDomain?: string | null, aiExtractedTextV1?: string | null, aiTranscriptionTextV1?: string | null, aiAdTypeV1?: string | null, aiCampaignHeadlineV1?: Array<string> | null, mediaTypeList: Array<{ id: string, name: string, canonicalName: string }>, mediaOwnerList: Array<{ id: string, name: string }>, publisherList: Array<{ id: string, name: string }>, publicationList: Array<{ id: string, name: string }>, regionList: Array<{ id: string, name: string }>, aiDemographicsV1?: Array<{ ageBracket?: string | null, ageName?: string | null, genderDistribution?: { unspecified?: number | null, female?: number | null, male?: number | null } | null }> | null, aiSummaryInsightsV1?: Array<{ summary150?: string | null, summary300?: string | null }> | null, aiTagsV1?: Array<{ advertiser?: string | null, industry?: string | null, category?: string | null, product?: string | null, fuelType?: string | null }> | null, compliance?: Array<{ compliance_code?: string | null, compliance_code_id?: string | null, compliance_risk_rating?: ComplianceRiskRating | null, compliance_reason?: string | null }> | null }> } } | null };

export type ComplianceCsvQueryVariables = Exact<{
  input: ComplianceCsvInput;
}>;


export type ComplianceCsvQuery = { compliance?: { csv: { csv: string, errorJson: string } } | null };

export type ComplianceReviewCreativeQueryVariables = Exact<{
  complianceCodeId: Scalars['String']['input'];
  creativeId: Scalars['String']['input'];
}>;


export type ComplianceReviewCreativeQuery = { compliance?: { creative: { creativeId: string, teamId: string, complianceCodeId: string, progressStatus: ComplianceCreativeProgressStatus, notes: Array<string>, shortlists?: Array<string> | null, createdAt: string, createdBy: string, updatedAt: string, updatedBy: string, history: Array<{ summary: string, actor: string, timestamp: string }>, creative?: { id: string, creative: string, firstAppeared?: string | null, lastAppeared?: string | null, status: CreativeStatusV2, country?: string | null, placementTypes?: Array<string> | null, advertiserDomain?: string | null, aiExtractedTextV1?: string | null, aiTranscriptionTextV1?: string | null, aiAdTypeV1?: string | null, aiCampaignHeadlineV1?: Array<string> | null, mediaTypeList: Array<{ id: string, name: string, canonicalName: string }>, mediaOwnerList: Array<{ id: string, name: string }>, publisherList: Array<{ id: string, name: string }>, publicationList: Array<{ id: string, name: string }>, regionList: Array<{ id: string, name: string }>, compliance?: Array<{ compliance_code?: string | null, compliance_code_id?: string | null, compliance_risk_rating?: ComplianceRiskRating | null, compliance_reason?: string | null }> | null } | null } } | null };

export type ComplianceUpdateCreativeMutationVariables = Exact<{
  input: ComplianceCreativeUpdateMutationInput;
}>;


export type ComplianceUpdateCreativeMutation = { compliance?: { updateComplianceCreative: { creativeId: string, teamId: string, complianceCodeId: string, progressStatus: ComplianceCreativeProgressStatus, notes: Array<string>, shortlists?: Array<string> | null, createdAt: string, createdBy: string, updatedAt: string, updatedBy: string, history: Array<{ summary: string, actor: string, timestamp: string }> } } | null };

export type CreativeItemV2QueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type CreativeItemV2Query = { creativeV2?: { publicCreativeItemV2: { id: string, creative: string, firstAppeared?: string | null, lastAppeared?: string | null, status: CreativeStatusV2, country?: string | null, placementTypes: Array<string>, advertiserDomain?: string | null, aiExtractedTextV1?: string | null, aiTranscriptionTextV1?: string | null, aiAdTypeV1?: string | null, mediaOwnerList: Array<{ id: string, name: string }>, mediaTypeList: Array<{ id: string, name: string, canonicalName: string }>, publisherList: Array<{ id: string, name: string }>, publicationList: Array<{ id: string, name: string }>, regionList: Array<{ id: string, name: string }>, aiDemographicsV1?: Array<{ ageBracket?: string | null, ageName?: string | null, genderDistribution?: { unspecified?: number | null, female?: number | null, male?: number | null } | null }> | null, aiSummaryInsightsV1?: Array<{ summary150?: string | null, summary300?: string | null }> | null, aiTagsV1?: Array<{ advertiser?: string | null, industry?: string | null, category?: string | null, product?: string | null, fuelType?: string | null }> | null, compliance?: Array<{ compliance_code?: string | null, compliance_code_id?: string | null, compliance_risk_rating?: ComplianceRiskRating | null, compliance_reason?: string | null }> | null } } | null };

export type ComplianceCreativeItemV2QueryVariables = Exact<{
  creativeId: Scalars['ID']['input'];
}>;


export type ComplianceCreativeItemV2Query = { creativeV2?: { publicCreativeItemV2: { id: string, creative: string, firstAppeared?: string | null, lastAppeared?: string | null, status: CreativeStatusV2, country?: string | null, placementTypes: Array<string>, advertiserDomain?: string | null, aiExtractedTextV1?: string | null, aiTranscriptionTextV1?: string | null, aiAdTypeV1?: string | null, mediaOwnerList: Array<{ id: string, name: string }>, mediaTypeList: Array<{ id: string, name: string, canonicalName: string }>, publisherList: Array<{ id: string, name: string }>, publicationList: Array<{ id: string, name: string }>, regionList: Array<{ id: string, name: string }>, aiDemographicsV1?: Array<{ ageBracket?: string | null, ageName?: string | null, genderDistribution?: { unspecified?: number | null, female?: number | null, male?: number | null } | null }> | null, aiSummaryInsightsV1?: Array<{ summary150?: string | null, summary300?: string | null }> | null, aiTagsV1?: Array<{ advertiser?: string | null, industry?: string | null, category?: string | null, product?: string | null, fuelType?: string | null }> | null, compliance?: Array<{ compliance_code?: string | null, compliance_code_id?: string | null, compliance_risk_rating?: ComplianceRiskRating | null, compliance_reason?: string | null }> | null } } | null };

export type CreativeListV2QueryVariables = Exact<{
  input: CreativeListInputV2;
}>;


export type CreativeListV2Query = { creativeV2?: { creativeListV2: { totalCount: number, paginationInfo?: { hasPreviousPage: boolean, hasNextPage: boolean, currentPage: number } | null, items: Array<{ id: string, creative: string, firstAppeared?: string | null, lastAppeared?: string | null, status: CreativeStatusV2, country?: string | null, placementTypes?: Array<string> | null, advertiserDomain?: string | null, aiExtractedTextV1?: string | null, aiTranscriptionTextV1?: string | null, aiAdTypeV1?: string | null, aiCampaignHeadlineV1?: Array<string> | null, mediaTypeList: Array<{ id: string, name: string, canonicalName: string }>, mediaOwnerList: Array<{ id: string, name: string }>, publisherList: Array<{ id: string, name: string }>, publicationList: Array<{ id: string, name: string }>, regionList: Array<{ id: string, name: string }>, aiDemographicsV1?: Array<{ ageBracket?: string | null, ageName?: string | null, genderDistribution?: { unspecified?: number | null, female?: number | null, male?: number | null } | null }> | null, aiSummaryInsightsV1?: Array<{ summary150?: string | null, summary300?: string | null }> | null, aiTagsV1?: Array<{ advertiser?: string | null, industry?: string | null, category?: string | null, product?: string | null, fuelType?: string | null }> | null, compliance?: Array<{ compliance_code?: string | null, compliance_code_id?: string | null, compliance_risk_rating?: ComplianceRiskRating | null, compliance_reason?: string | null }> | null }> } } | null };

export type CreativeDownloadQueryVariables = Exact<{
  input: CreativeDownloadInput;
}>;


export type CreativeDownloadQuery = { creativeV2?: { creativeDownload: { downloadLink: string } } | null };

export type CreativeMediaValueQueryVariables = Exact<{
  input: CreativeMediaValueInput;
}>;


export type CreativeMediaValueQuery = { creativeV2?: { creativeMediaValue: Array<{ date: string, normalizedSpend: number }> } | null };

export type GroupByCampaignQueryVariables = Exact<{
  input: GroupByCampaignInput;
}>;


export type GroupByCampaignQuery = { creativeV2?: { groupByCampaign: { items: Array<{ campaignName: string, creativeCount: number, thumbnailCreative: string, status: CreativeStatusV2, firstAppeared: string, lastAppeared: string, region: Array<string>, mediaType: Array<string>, publication: Array<string>, publisher: Array<string>, mediaOwner: Array<string>, aiAdType: Array<string>, aiProducts: Array<string>, aiCategories: Array<string>, aiIndustries: Array<string>, aiAdvertisers: Array<string>, country: string }>, paginationInfo?: { afterKey?: string | null, nextPageMayContainMoreCampaigns: boolean } | null } } | null };

export type FilterQueryQueryVariables = Exact<{
  input: FilterInputV2;
  filter?: InputMaybe<FilterForFilteringFiltersV2>;
  options?: InputMaybe<FilterOptions>;
}>;


export type FilterQueryQuery = { filterV2?: { filters?: { column: FilterColumnV2, pageInfo: { currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items: { advertiserDomain?: Array<{ id: string, name: string }> | null, publication?: Array<{ id: string, name: string }> | null, publisher?: Array<{ id: string, name: string }> | null, region?: Array<{ id: string, name: string }> | null, mediaOwner?: Array<{ id: string, name: string }> | null, mediaType?: Array<{ id: string, name: string, canonicalName: string }> | null, changeset?: Array<{ id: string, name: string, status: string }> | null, segment?: Array<{ id: string, name: string, color: string, emailAlert: boolean, teamId: string, createdAt: string, updatedAt: string, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> }, author: { id: string, name: string, email: string } }> | null, status?: Array<{ id: string, name: string }> | null, placementType?: Array<{ id: string, name: string }> | null } } | null } | null };

export type CreativeAiFiltersQueryVariables = Exact<{
  input: FilterAiInputV2;
  filter?: InputMaybe<AiFilters>;
}>;


export type CreativeAiFiltersQuery = { aiEntities?: { filterAiEntitiesV2: { column: FilterAiColumn, pageInfo?: { nextOffset?: number | null, hasNextPage?: boolean | null } | null, items: { aiAdvertiserV1: Array<{ name: string, hasAccess?: boolean | null }>, aiCategoryV1: Array<{ name: string, hasAccess?: boolean | null }>, aiIndustryV1: Array<{ name: string, hasAccess?: boolean | null }>, aiProductV1: Array<{ name: string, hasAccess?: boolean | null }>, aiFuelTypeV1: Array<{ name: string, hasAccess?: boolean | null }> } } } | null };

export type MediaValueAiFiltersQueryVariables = Exact<{
  input: MediaValueFilterInput;
  filter?: InputMaybe<MediaValueFilters>;
}>;


export type MediaValueAiFiltersQuery = { mediaValueEntities?: { filterMediaValueEntities: { column: MediaValueFilterColumn, pageInfo?: { nextOffset?: number | null, hasNextPage?: boolean | null } | null, items: { aiAdvertiserV1: Array<{ name: string, hasAccess?: boolean | null }>, aiCategoryV1: Array<{ name: string, hasAccess?: boolean | null }>, aiIndustryV1: Array<{ name: string, hasAccess?: boolean | null }>, aiProductV1: Array<{ name: string, hasAccess?: boolean | null }>, aiFuelTypeV1: Array<{ name: string, hasAccess?: boolean | null }> } } } | null };

export type GetEntitiesByIdQueryVariables = Exact<{
  input: GetEntitiesByIdInput;
}>;


export type GetEntitiesByIdQuery = { filterV2?: { getEntitiesById: { adType: Array<{ id: string, name: string, canonicalName: string }>, brand: Array<{ id: string, name: string, industries?: Array<{ id: string, name: string }> | null }>, industry: Array<{ id: string, name: string }>, category: Array<{ id: string, name: string, industry?: { id: string, name: string } | null }>, campaign: Array<{ id: string, name: string }>, publisher?: Array<{ id: string, name: string }> | null, publication: Array<{ id: string, name: string }>, region: Array<{ id: string, name: string }>, product: Array<{ id: string, name: string, brand?: { id: string, name: string } | null }>, mediaOwner: Array<{ id: string, name: string }>, mediaType: Array<{ id: string, name: string, canonicalName: string }>, changeset: Array<{ id: string, name: string, status: string }>, segment: Array<{ id: string, name: string, color: string, emailAlert: boolean, teamId: string, createdAt: string, updatedAt: string, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> }, author: { id: string, name: string, email: string } }> } } | null };

export type ConvertNamesToEntitiesQueryVariables = Exact<{
  input: ConvertNameToEntitiesInput;
}>;


export type ConvertNamesToEntitiesQuery = { filterV2?: { convertNamesToEntities?: { adType?: Array<{ id: string, name: string, canonicalName: string }> | null, brand?: Array<{ id: string, name: string }> | null, industry?: Array<{ id: string, name: string }> | null, mediaType?: Array<{ id: string, name: string, canonicalName: string }> | null, region?: Array<{ id: string, name: string }> | null, publisher?: Array<{ id: string, name: string }> | null, publication?: Array<{ id: string, name: string }> | null, mediaOwner?: Array<{ id: string, name: string }> | null, mediaTypeSynonym?: Array<{ id: string, name: string, canonicalName: string }> | null } | null } | null };

export type ConvertNameFiltersToIdsQueryVariables = Exact<{
  input: ConvertFiltersInput;
}>;


export type ConvertNameFiltersToIdsQuery = { filterV2?: { convertNameFiltersToIds?: { adType?: Array<string> | null, brand?: Array<string> | null, category?: Array<string> | null, industry?: Array<string> | null, mediaType?: Array<string> | null, product?: Array<string> | null, region?: Array<string> | null } | null } | null };

export type GmvFilterQueryQueryVariables = Exact<{
  country: SupportedCountry;
  column: GlobalMediaValueInputColumn;
  searchText?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GlobalMediaValueColumnFilter>;
  size?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  restrictedItemDisplayType?: InputMaybe<GlobalMediaValueRestrictedtemDisplayType>;
}>;


export type GmvFilterQueryQuery = { globalMediaValue: { filterQuery: { after?: string | null, items: Array<{ column: GlobalMediaValueInputColumn, value: string, isLocked?: boolean | null }> } } };

export type MediaValueRowsV3QueryVariables = Exact<{
  columns?: InputMaybe<Array<MediaValueInputColumn>>;
  columnFilter?: InputMaybe<MediaValueColumnFilter>;
  excludeFilter?: InputMaybe<MediaValueExcludeList>;
  dateRangeFilter?: InputMaybe<MediaValueDateRangeFilter>;
  pagination?: InputMaybe<MediaValuePagination>;
  changesetId?: InputMaybe<Scalars['Int']['input']>;
  adType: Scalars['Boolean']['input'];
  brand: Scalars['Boolean']['input'];
  campaign: Scalars['Boolean']['input'];
  category: Scalars['Boolean']['input'];
  industry: Scalars['Boolean']['input'];
  mediaOwner: Scalars['Boolean']['input'];
  mediaType: Scalars['Boolean']['input'];
  product: Scalars['Boolean']['input'];
  publisher: Scalars['Boolean']['input'];
  region: Scalars['Boolean']['input'];
  segment: Scalars['Boolean']['input'];
  publication: Scalars['Boolean']['input'];
  fuelType: Scalars['Boolean']['input'];
}>;


export type MediaValueRowsV3Query = { mediaValue: { rowsV3: { grandTotal: number, rows: Array<{ date: string, value: number, adType?: string | null, brand?: string | null, campaign?: string | null, category?: string | null, industry?: string | null, mediaOwner?: string | null, mediaType?: string | null, product?: string | null, publisher?: string | null, region?: string | null, segment?: string | null, publication?: string | null, fuelType?: string | null }>, labels: { segment?: Array<{ id: string, name: string, color: string }> }, columnTotals: Array<{ column: string, value: number }>, pageInfo: { currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, meta?: { isTruncated: boolean } | null } } };

export type MediaValueCsvV3QueryVariables = Exact<{
  columns?: InputMaybe<Array<MediaValueInputColumn>>;
  columnFilter?: InputMaybe<MediaValueColumnFilter>;
  dateRangeFilter?: InputMaybe<MediaValueDateRangeFilter>;
  csvFileName?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<MediaValuePagination>;
  changesetId?: InputMaybe<Scalars['Int']['input']>;
  includePercentage?: InputMaybe<Scalars['Boolean']['input']>;
  includeDollarFigureForSOVReports?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MediaValueCsvV3Query = { mediaValue: { csvV3: { csv: string } } };

export type GmvExpenditureReportCsvExportQueryVariables = Exact<{
  columns?: InputMaybe<Array<GlobalMediaValueInputColumn>>;
  columnFilter?: InputMaybe<GlobalMediaValueColumnFilter>;
  dateRangeFilter?: InputMaybe<GlobalMediaValueDateRangeFilter>;
  csvFileName?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<GlobalMediaValuePagination>;
  country: SupportedCountry;
  includePercentage?: InputMaybe<Scalars['Boolean']['input']>;
  includeDollarFigureForSOVReports?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GmvExpenditureReportCsvExportQuery = { globalMediaValue: { csv: { csv: string } } };

export type DistributionV3QueryVariables = Exact<{
  dateRangeFilter: MediaValueDateRangeFilter;
  breakdownColumn: MediaValueBreakdownColumn;
  rows: Array<MediaValueRowFilterInput>;
}>;


export type DistributionV3Query = { mediaValue: { distributionV3: { rows: { [key: string]: any }, columnMeta: { [key: string]: any } } } };

export type GmvDistributionQueryVariables = Exact<{
  dateRangeFilter: GlobalMediaValueDateRangeFilter;
  breakdownColumn: GlobalMediaValueBreakdownColumn;
  rows: Array<GlobalMediaValueRowFilterInput>;
  country: SupportedCountry;
}>;


export type GmvDistributionQuery = { globalMediaValue: { distribution: { rows: { [key: string]: any }, columnMeta: { [key: string]: any } } } };

export type ComparisonV3QueryVariables = Exact<{
  periodSelection: PeriodSelection;
  rows: Array<MediaValueRowFilterInput>;
}>;


export type ComparisonV3Query = { mediaValue: { comparisonV3: { rows: { [key: string]: any }, columnMeta: { [key: string]: any } } } };

export type GmvComparisonQueryVariables = Exact<{
  periodSelection: GlobalMediaValuePeriodSelection;
  rows: Array<GlobalMediaValueRowFilterInput>;
  country: SupportedCountry;
}>;


export type GmvComparisonQuery = { globalMediaValue: { comparison: { rows: { [key: string]: any }, columnMeta: { [key: string]: any } } } };

export type GetForecastDatesQueryVariables = Exact<{
  queryOpensearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetForecastDatesQuery = { mediaValue: { getForecastDates: { forecastCutoff: string, forecastCutoffDigital: string, maxDate: string } } };

export type GmvStatsQueryQueryVariables = Exact<{
  country: SupportedCountry;
}>;


export type GmvStatsQueryQuery = { globalMediaValue: { stats: { latestDate: string } } };

export type GmvExpenditureReportQueryVariables = Exact<{
  country: SupportedCountry;
  columns?: InputMaybe<Array<GlobalMediaValueInputColumn>>;
  columnFilter?: InputMaybe<GlobalMediaValueColumnFilter>;
  excludeFilter?: InputMaybe<GlobalMediaValueExcludeList>;
  dateRangeFilter?: InputMaybe<GlobalMediaValueDateRangeFilter>;
  pagination?: InputMaybe<GlobalMediaValuePagination>;
  includeColumnTotals: Scalars['Boolean']['input'];
  adType: Scalars['Boolean']['input'];
  brand: Scalars['Boolean']['input'];
  category: Scalars['Boolean']['input'];
  industry: Scalars['Boolean']['input'];
  mediaType: Scalars['Boolean']['input'];
  product: Scalars['Boolean']['input'];
  publication: Scalars['Boolean']['input'];
  region: Scalars['Boolean']['input'];
  fuelType: Scalars['Boolean']['input'];
}>;


export type GmvExpenditureReportQuery = { globalMediaValue: { expenditureReport: { grandTotal?: number | null, cells: Array<{ date: string, value: number, adType?: string | null, brand?: string | null, category?: string | null, industry?: string | null, mediaType?: string | null, product?: string | null, publication?: string | null, region?: string | null, fuelType?: string | null }>, columnTotals?: Array<{ column: string, value: number }> | null, pageInfo: { currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, meta?: { isTruncated: boolean } | null } } };

export type ReportQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReportQueryQuery = { reportV2?: { report: { id: string, status: string, teamId: string, teamName?: string | null, name: string, description?: string | null, createdAt: string, updatedAt: string, iconName: string, iconColor: string, country: string, user?: { id: string, name: string } | null, items: Array<{ id: string, name?: string | null, type: ReportItemType, description?: string | null, definitionV2: { [key: string]: any }, teamId: string, createdAt: string, status: string, updateAt: string, userId: string }>, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } } | null };

export type ReportCreateMutationVariables = Exact<{
  input: ReportCreateInput;
}>;


export type ReportCreateMutation = { reportV2?: { reportCreate: { id: string, teamId: string, teamName?: string | null, name: string, description?: string | null, createdAt: string, updatedAt: string, iconName: string, iconColor: string, country: string, status: string, user?: { id: string, name: string } | null, items: Array<{ id: string }>, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } } | null };

export type ReportUpdateMutationVariables = Exact<{
  input: ReportUpdateInput;
}>;


export type ReportUpdateMutation = { reportV2?: { reportUpdate?: { id: string, teamId: string, teamName?: string | null, name: string, description?: string | null, createdAt: string, updatedAt: string, iconName: string, iconColor: string, status: string, country: string, user?: { id: string, name: string } | null, items: Array<{ id: string, userId: string, teamId: string, type: ReportItemType, definitionV2: { [key: string]: any }, createdAt: string, updateAt: string, status: string, name?: string | null, description?: string | null }>, sharing: { status: SharedStatus, usersWithAccess: Array<{ name: string, id: string, email: string }> } } | null } | null };

export type ReportRemoveMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReportRemoveMutation = { reportV2?: { reportRemove: boolean } | null };

export type ReportDuplicateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReportDuplicateMutation = { reportV2?: { reportDuplicate?: { id: string, teamId: string, teamName?: string | null, name: string, description?: string | null, createdAt: string, updatedAt: string, iconName: string, iconColor: string, status: string, country: string, user?: { id: string, name: string } | null, items: Array<{ id: string, userId: string, teamId: string, type: ReportItemType, definitionV2: { [key: string]: any }, createdAt: string, updateAt: string, status: string, name?: string | null, description?: string | null }>, sharing: { status: SharedStatus, usersWithAccess: Array<{ name: string, id: string, email: string }> } } | null } | null };

export type ReportListV3QueryQueryVariables = Exact<{
  input: ReportListInput;
}>;


export type ReportListV3QueryQuery = { reportV3?: { reportList: { items: Array<{ id: string, teamId: string, status: string, teamName?: string | null, name: string, description?: string | null, iconName: string, iconColor: string, createdAt: string, updatedAt: string, country: string, user?: { id: string, name: string } | null, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } }>, pagination: { page: number, count: number, hasNextPage: boolean } } } | null };

export type ReportRemoveManyMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']>;
}>;


export type ReportRemoveManyMutation = { reportV2?: { reportRemoveMany: Array<{ id: string, teamId: string, teamName?: string | null, name: string, description?: string | null, createdAt: string, updatedAt: string, iconName: string, iconColor: string, status: string, country: string, user?: { id: string, name: string } | null, sharing: { status: SharedStatus, usersWithAccess: Array<{ name: string, id: string, email: string }> } }> } | null };

export type ReportShareManyMutationVariables = Exact<{
  input: ReportShareManyInput;
}>;


export type ReportShareManyMutation = { reportV2?: { reportShareMany: Array<{ id: string, teamId: string, teamName?: string | null, name: string, description?: string | null, createdAt: string, updatedAt: string, iconName: string, iconColor: string, status: string, country: string, user?: { id: string, name: string } | null, sharing: { status: SharedStatus, usersWithAccess: Array<{ name: string, id: string, email: string }> } }> } | null };

export type ReportSearchQueryVariables = Exact<{
  input: ReportSearchInput;
}>;


export type ReportSearchQuery = { reportV2?: { reportSearch: Array<{ id: string, teamId: string, teamName?: string | null, name: string, description?: string | null, iconName: string, iconColor: string, createdAt: string, updatedAt: string, status: string, country: string, user?: { id: string, name: string } | null, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } }> } | null };

export type ReportItemCreateMutationVariables = Exact<{
  input: ReportItemV2CreateInput;
}>;


export type ReportItemCreateMutation = { reportV2?: { reportItemCreate: { id: string, userId: string, teamId: string, type: ReportItemType, definitionV2: { [key: string]: any }, createdAt: string, updateAt: string, status: string, name?: string | null, description?: string | null } } | null };

export type ReportItemRemoveMutationVariables = Exact<{
  input: ReportItemRemoveInput;
}>;


export type ReportItemRemoveMutation = { reportV2?: { reportItemRemove: boolean } | null };

export type ReportItemUpdateMutationVariables = Exact<{
  input: ReportItemV2UpdateInput;
}>;


export type ReportItemUpdateMutation = { reportV2?: { reportItemUpdate: { id: string, userId: string, teamId: string, type: ReportItemType, definitionV2: { [key: string]: any }, createdAt: string, updateAt: string, status: string, name?: string | null, description?: string | null } } | null };

export type PdfReportCreateMutationMutationVariables = Exact<{
  reportId: Scalars['UUID']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  printConfig?: InputMaybe<Scalars['String']['input']>;
}>;


export type PdfReportCreateMutationMutation = { pdfRenderer?: { pdfReportCreate: { downloadLink: string } } | null };

export type PdfCreativeProfileMutationMutationVariables = Exact<{
  filter: Scalars['String']['input'];
  appUrl: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  printConfig?: InputMaybe<Scalars['String']['input']>;
}>;


export type PdfCreativeProfileMutationMutation = { pdfRenderer?: { pdfCreative: { downloadLink: string } } | null };

export type SearchQueryVariables = Exact<{
  search: SearchInputV2;
}>;


export type SearchQuery = { searchV2?: { search: { pageInfo: { currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ name: string, type: ResultTypeV2, id: string, hasAccess: boolean, industries?: Array<{ id: string, name: string, type: string }> | null }> } } | null };

export type OnboardingSearchQueryVariables = Exact<{
  search: OnboardingSearchInput;
}>;


export type OnboardingSearchQuery = { searchV2?: { onboardingSearch: { pageInfo: { currentPage: number, hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ name: string, type: ResultTypeV2, id: string, hasAccess: boolean, industries?: Array<{ id: string, name: string, type: string }> | null }> } } | null };

export type CreativeEmailSegmentCreateMutationVariables = Exact<{
  input: SegmentV2CreateInput;
}>;


export type CreativeEmailSegmentCreateMutation = { segmentV2?: { segmentCreate: { id: string, name: string, color: string, teamId: string, teamName?: string | null, description?: string | null, definitionV2: { [key: string]: any }, emailAlert: boolean, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { id: string, name: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } } | null };

export type CreativeEmailSegmentUpdateMutationVariables = Exact<{
  input: CreativeEmailSegmentUpdateInput;
}>;


export type CreativeEmailSegmentUpdateMutation = { segmentV2?: { creativeEmailSegmentUpdate?: { id: string, name: string, color: string, teamId: string, description?: string | null, definitionV2: { [key: string]: any }, emailAlert: boolean, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { id: string, name: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } | null } | null };

export type CreativeEmailSegmentQueryQueryVariables = Exact<{
  input?: InputMaybe<CreativeEmailSegmentInput>;
}>;


export type CreativeEmailSegmentQueryQuery = { segmentV2?: { creativeEmailSegment?: { id: string, name: string, color: string, teamId: string, description?: string | null, definitionV2: { [key: string]: any }, emailAlert: boolean, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { id: string, name: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } | null } | null };

export type SegmentCreateMutationMutationVariables = Exact<{
  input: SegmentV2CreateInput;
}>;


export type SegmentCreateMutationMutation = { segmentV2?: { segmentCreate: { id: string, name: string, color: string, teamId: string, teamName?: string | null, description?: string | null, definitionV2: { [key: string]: any }, createdAt: string, updatedAt: string, status?: DeletedStatus | null, emailAlert: boolean, author: { id: string, name: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } } | null };

export type SegmentListQueryQueryVariables = Exact<{
  input?: InputMaybe<SegmentListOptions>;
}>;


export type SegmentListQueryQuery = { segmentV2?: { segmentList: { data: Array<{ id: string, name: string, color: string, teamId: string, teamName?: string | null, description?: string | null, definitionV2?: { [key: string]: any } | null, emailAlert?: boolean | null, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { id: string, name: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } | null> } } | null };

export type SegmentUpdateMutationMutationVariables = Exact<{
  input: SegmentV2UpdateInput;
}>;


export type SegmentUpdateMutationMutation = { segmentV2?: { segmentUpdate?: { id: string, name: string, color: string, teamId: string, teamName?: string | null, description?: string | null, definitionV2: { [key: string]: any }, emailAlert: boolean, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { id: string, name: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } | null } | null };

export type SegmentRemoveMutationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SegmentRemoveMutationMutation = { segmentV2?: { segmentRemove?: boolean | null } | null };

export type SegmentV2QueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreSharing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SegmentV2QueryQuery = { segmentV2?: { segment: { id: string, name: string, color: string, teamId: string, teamName?: string | null, description?: string | null, definitionV2: { [key: string]: any }, emailAlert: boolean, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { id: string, name: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } } | null };

export type SegmentRemoveManyMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']>;
}>;


export type SegmentRemoveManyMutation = { segmentV2?: { segmentRemoveMany: { data: Array<{ id: string, name: string, color: string, description?: string | null, teamId: string, teamName?: string | null, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { name: string, id: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string }> } } | null> } } | null };

export type SegmentShareManyMutationVariables = Exact<{
  input: SegmentV2ShareManyInput;
}>;


export type SegmentShareManyMutation = { segmentV2?: { segmentShareMany: { data: Array<{ id: string, name: string, color: string, description?: string | null, teamId: string, teamName?: string | null, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { name: string, id: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string }> } } | null> } } | null };

export type SegmentSearchQueryQueryVariables = Exact<{
  input: SegmentSearchInput;
}>;


export type SegmentSearchQueryQuery = { segmentV2?: { segmentSearch: { data: Array<{ id: string, name: string, color: string, description?: string | null, teamId: string, teamName?: string | null, createdAt: string, updatedAt: string, status?: DeletedStatus | null, emailAlert?: boolean | null, author: { name: string, id: string, email: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } | null> } } | null };

export type SegmentNzUnsubsribeMutationMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type SegmentNzUnsubsribeMutationMutation = { segmentV2?: { nzUnsubscribe?: boolean | null } | null };

export type TeamIncrementDownloadCountMutationMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type TeamIncrementDownloadCountMutationMutation = { team?: { teamIncrementDownloadCount?: { id: string, metadata?: { [key: string]: any } | null, updatedAt?: string | null } | null } | null };

export type TeamItemQueryQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type TeamItemQueryQuery = { team?: { team: { id: string, name: string, createdAt?: string | null, updatedAt?: string | null, members: Array<{ teamId: string, userId: string, role: TeamMemberRole, createdAt?: string | null, updatedAt?: string | null, user?: { id: string, username: string, name: string } | null }>, products?: Array<{ product: string, industryIds?: Array<string> | null, mediaTypeIds?: Array<string> | null, status?: TeamProductStatus | null, metadata?: { [key: string]: any } | null, country?: string | null, compliance?: { AU?: { AANA_CODE_OF_ETHICS?: Array<string> | null, AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE?: Array<string> | null, AANA_CHILDRENS_ADVERTISING_CODE?: Array<string> | null, AANA_ENVIRONMENTAL_CLAIMS_CODE?: Array<string> | null, AANA_WAGERING_ADVERTISING_CODE?: Array<string> | null, FCAI_CODE?: Array<string> | null, TGA_CODE?: Array<string> | null, ABAC_CODE?: Array<string> | null } | null } | null } | null> | null, invites: Array<{ id: string, username: string, role: TeamMemberRole, status: UserInviteStatus, createdAt?: string | null, team?: { id: string } | null, inviter?: { id: string } | null }> } } | null };

export type TeamCreateWithInviteMutationVariables = Exact<{
  teamName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  inviterId: Scalars['String']['input'];
}>;


export type TeamCreateWithInviteMutation = { team?: { teamCreateWithInvite?: { id: string, name: string, status?: TeamStatus | null, createdAt?: string | null, updatedAt?: string | null, invites: Array<{ id: string, username: string, role: TeamMemberRole, status: UserInviteStatus, createdAt?: string | null }> } | null } | null };

export type TeamInviteResendMutationMutationVariables = Exact<{
  inviteId: Scalars['UUID']['input'];
}>;


export type TeamInviteResendMutationMutation = { team?: { teamResendInvite: boolean } | null };

export type TeamRemoveInviteMutationMutationVariables = Exact<{
  inviteId: Scalars['UUID']['input'];
}>;


export type TeamRemoveInviteMutationMutation = { team?: { teamRemoveInvite: boolean } | null };

export type TeamMemberRemoveMutationMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  teamId: Scalars['UUID']['input'];
}>;


export type TeamMemberRemoveMutationMutation = { team?: { teamRemoveUser: boolean } | null };

export type TeamMemberUpdateMutationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  userId: Scalars['String']['input'];
  role: TeamMemberRole;
}>;


export type TeamMemberUpdateMutationMutation = { team?: { teamUpdateUser?: { teamId: string, userId: string, role: TeamMemberRole, updatedAt?: string | null } | null } | null };

export type TeamResetDownloadCountMutationMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type TeamResetDownloadCountMutationMutation = { team?: { teamResetDownloadCount?: { id: string, metadata?: { [key: string]: any } | null, updatedAt?: string | null } | null } | null };

export type TeamMemberAddMutationMutationVariables = Exact<{
  member: AddUserToTeamInput;
}>;


export type TeamMemberAddMutationMutation = { team?: { teamAddUser?: { userId: string, teamId: string, role: TeamMemberRole, status?: TeamMemberStatus | null, createdAt?: string | null, team?: { id: string, members: Array<{ userId: string, role: TeamMemberRole, status?: TeamMemberStatus | null, createdAt?: string | null, updatedAt?: string | null, user?: { id: string, username: string, name: string } | null }> } | null } | null } | null };

export type TeamMemberInviteMutationMutationVariables = Exact<{
  invite: InviteUserToTeamInput;
}>;


export type TeamMemberInviteMutationMutation = { team?: { teamInviteUser?: { id: string, username: string, role: TeamMemberRole, status: UserInviteStatus, createdAt?: string | null, team?: { id: string, members: Array<{ userId: string, role: TeamMemberRole, status?: TeamMemberStatus | null, createdAt?: string | null, updatedAt?: string | null, user?: { id: string, username: string, name: string } | null }>, invites: Array<{ id: string, username: string, role: TeamMemberRole, status: UserInviteStatus, createdAt?: string | null, inviter?: { id: string } | null }> } | null, inviter?: { id: string } | null } | null } | null };

export type RemoveTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type RemoveTeamMutation = { team?: { teamRemove: boolean } | null };

export type TeamUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type TeamUpdateMutation = { team?: { teamUpdate?: { id: string, name: string } | null } | null };

export type TeamUpdateProductsMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  products: Array<TeamProductInput>;
}>;


export type TeamUpdateProductsMutation = { team?: { teamUpdateProducts?: Array<{ product: string, industryIds?: Array<string> | null, mediaTypeIds?: Array<string> | null, status?: TeamProductStatus | null, metadata?: { [key: string]: any } | null, country?: string | null, compliance?: { AU?: { AANA_CODE_OF_ETHICS?: Array<string> | null, AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE?: Array<string> | null, AANA_CHILDRENS_ADVERTISING_CODE?: Array<string> | null, AANA_ENVIRONMENTAL_CLAIMS_CODE?: Array<string> | null, AANA_WAGERING_ADVERTISING_CODE?: Array<string> | null, FCAI_CODE?: Array<string> | null, TGA_CODE?: Array<string> | null, ABAC_CODE?: Array<string> | null } | null } | null } | null> | null } | null };

export type TeamListQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TeamProductStatusFilter>;
  country?: InputMaybe<Scalars['String']['input']>;
  industryList?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type TeamListQueryQuery = { team?: { teamList: Array<{ id: string, name: string, status?: TeamStatus | null, createdAt?: string | null, updatedAt?: string | null, members: Array<{ teamId: string, userId: string }>, products?: Array<{ product: string, status?: TeamProductStatus | null, industryIds?: Array<string> | null, metadata?: { [key: string]: any } | null, country?: string | null } | null> | null }> } | null };

export type TeamAddNzTrialMutationVariables = Exact<{
  input: AddNzTrialInput;
}>;


export type TeamAddNzTrialMutation = { team?: { teamAddNzTrial: { id: string, name: string, status?: TeamStatus | null, createdAt?: string | null, updatedAt?: string | null, metadata?: { [key: string]: any } | null, members: Array<{ teamId: string, userId: string, user?: { username: string, id: string } | null }>, products?: Array<{ product: string, status?: TeamProductStatus | null, industryIds?: Array<string> | null, metadata?: { [key: string]: any } | null, country?: string | null } | null> | null } } | null };

export type SubmitFormMutationVariables = Exact<{
  formId: Scalars['String']['input'];
  formInput: Array<TrackingFormField>;
}>;


export type SubmitFormMutation = { tracking?: { submitHubspotForm?: boolean | null } | null };

export type SubmitUserCreatedAccountFormMutationVariables = Exact<{
  country: SupportedCountry;
}>;


export type SubmitUserCreatedAccountFormMutation = { tracking?: { submitUserCreatedAccountForm?: boolean | null } | null };

export type UserListQueryQueryVariables = Exact<{
  pagination?: InputMaybe<UserListPagination>;
  orderBy?: InputMaybe<UserListOrderBy>;
  filter?: InputMaybe<UserListFilter>;
}>;


export type UserListQueryQuery = { user?: { userList: Array<{ id: string, username: string, name: string, createdAt?: string | null, updatedAt?: string | null, status?: { australianMediaValue: TeamProductStatuses, australianCreative: TeamProductStatuses, newZealandCreative: TeamProductStatuses, adminProducts?: Array<TeamAdminProducts | null> | null } | null, memberships: Array<{ teamId: string, team?: { id: string, name: string } | null }> }> } | null };

export type UserUpdateSessionMetadataMutationMutationVariables = Exact<{
  user: UserUpdateSessionMetadataInput;
}>;


export type UserUpdateSessionMetadataMutationMutation = { user?: { userUpdateSessionMetadata?: { id: string, name: string, createdAt?: string | null, updatedAt?: string | null, phone?: string | null } | null } | null };

export type UserItemQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserItemQueryQuery = { user?: { user: { id: string, username: string, name: string, createdAt?: string | null, updatedAt?: string | null, status?: { australianMediaValue: TeamProductStatuses, australianCreative: TeamProductStatuses, newZealandCreative: TeamProductStatuses, adminProducts?: Array<TeamAdminProducts | null> | null } | null, memberships: Array<{ teamId: string, team?: { id: string, name: string } | null }> } } | null };

export type ReportChangeOwnershipMutationMutationVariables = Exact<{
  input: ReportChangeOwnershipInput;
}>;


export type ReportChangeOwnershipMutationMutation = { reportV2?: { reportChangeOwnership: { report: { id: string, teamId: string, teamName?: string | null, name: string, description?: string | null, iconName: string, iconColor: string, createdAt: string, updatedAt: string, user?: { id: string, name: string } | null, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string, email: string }> } } } } | null };

export type SegmentV2ChangeOwnershipMutationVariables = Exact<{
  input: SegmentV2ChangeOwnership;
}>;


export type SegmentV2ChangeOwnershipMutation = { segmentV2?: { segmentChangeOwnership?: { id: string, name: string, color: string, teamId: string, teamName?: string | null, description?: string | null, definitionV2: { [key: string]: any }, createdAt: string, updatedAt: string, status?: DeletedStatus | null, author: { id: string, name: string }, sharing: { status: SharedStatus, usersWithAccess: Array<{ id: string, name: string }> } } | null } | null };

export type ViewerQueryQueryVariables = Exact<{
  options?: InputMaybe<ViewerQueryOptions>;
}>;


export type ViewerQueryQuery = { viewer?: { id: string, userOnboardingInfo: { isAustraliaOnboarded: boolean }, teams: Array<{ id: string, name: string, role: TeamMemberRole, trialExpired?: boolean | null, hasTrialTeamName?: boolean | null, requestedNzTrial?: boolean | null, downloadCount?: number | null, products: Array<{ product: string, industryIds?: Array<string> | null, industries?: Array<string> | null, mediaTypes?: Array<string> | null, mediaTypeIds?: Array<string> | null, status?: TeamProductStatus | null, metadata?: { [key: string]: any } | null, country?: string | null, compliance?: { AU?: { AANA_CODE_OF_ETHICS?: Array<string> | null, AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE?: Array<string> | null, AANA_CHILDRENS_ADVERTISING_CODE?: Array<string> | null, AANA_ENVIRONMENTAL_CLAIMS_CODE?: Array<string> | null, AANA_WAGERING_ADVERTISING_CODE?: Array<string> | null, FCAI_CODE?: Array<string> | null, TGA_CODE?: Array<string> | null, ABAC_CODE?: Array<string> | null } | null } | null }> }>, user: { firstname: string, id: string, lastname: string, name: string, username: string, createdAt: string, registrationStatus?: string | null, sessionMetadata?: { [key: string]: any } | null } } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const FollowedBrandsDocument = new TypedDocumentString(`
    query FollowedBrands($input: DashboardQueryV3Input!) {
  dashboardV3 {
    followedBrands(input: $input) {
      brands {
        mediaValue {
          previousPeriodTotal
          currentPeriodTotal
          change
          hasAccess
          currentPeriod {
            month
            spend
          }
          previousPeriod {
            month
            spend
          }
        }
        creatives {
          id
          creative
          firstAppeared
          lastAppeared
          status
          adType {
            id
            name
            canonicalName
          }
          categoryList {
            id
            name
          }
          mediaTypeList {
            id
            name
            canonicalName
          }
          mediaOwnerList {
            id
            name
          }
          publicationList {
            id
            name
          }
          publisherList {
            id
            name
          }
          regionList {
            id
            name
          }
          productList {
            id
            name
            brand {
              id
              name
            }
          }
          brandList {
            id
            name
          }
          industryList {
            id
            name
          }
        }
        brand {
          name
          id
        }
      }
      paginationInfo {
        currentPage
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FollowedBrandsQuery, FollowedBrandsQueryVariables>;
export const TopBrandsDocument = new TypedDocumentString(`
    query TopBrands($input: DashboardQueryV3Input!) {
  dashboardV3 {
    topBrands(input: $input) {
      brands {
        mediaValue {
          previousPeriodTotal
          currentPeriodTotal
          change
          hasAccess
          currentPeriod {
            month
            spend
          }
          previousPeriod {
            month
            spend
          }
        }
        creatives {
          id
          creative
          firstAppeared
          lastAppeared
          status
          adType {
            id
            name
            canonicalName
          }
          categoryList {
            id
            name
          }
          mediaTypeList {
            id
            name
            canonicalName
          }
          mediaOwnerList {
            id
            name
          }
          publicationList {
            id
            name
          }
          publisherList {
            id
            name
          }
          regionList {
            id
            name
          }
          productList {
            id
            name
            brand {
              id
              name
            }
          }
          brandList {
            id
            name
          }
          industryList {
            id
            name
          }
        }
        brand {
          name
          id
        }
      }
      paginationInfo {
        currentPage
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TopBrandsQuery, TopBrandsQueryVariables>;
export const ComplianceCreativeListV2Document = new TypedDocumentString(`
    query complianceCreativeListV2($input: ComplianceCreativeListV2QueryInput!) {
  compliance {
    creativeListV2(input: $input) {
      paginationInfo {
        nextPageCursor
        mightHaveNextPage
        receivedCreatives
      }
      items {
        progressStatus
        id
        creative
        firstAppeared
        lastAppeared
        status
        mediaTypeList {
          id
          name
          canonicalName
        }
        mediaOwnerList {
          id
          name
        }
        publisherList {
          id
          name
        }
        publicationList {
          id
          name
        }
        regionList {
          id
          name
        }
        country
        placementTypes
        advertiserDomain
        aiExtractedTextV1
        aiTranscriptionTextV1
        aiAdTypeV1
        aiCampaignHeadlineV1
        aiDemographicsV1 {
          genderDistribution {
            unspecified
            female
            male
          }
          ageBracket
          ageName
        }
        aiSummaryInsightsV1 {
          summary150
          summary300
        }
        aiTagsV1 {
          advertiser
          industry
          category
          product
          fuelType
        }
        compliance {
          compliance_code
          compliance_code_id
          compliance_risk_rating
          compliance_reason
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ComplianceCreativeListV2Query, ComplianceCreativeListV2QueryVariables>;
export const ComplianceCsvDocument = new TypedDocumentString(`
    query ComplianceCsv($input: ComplianceCsvInput!) {
  compliance {
    csv(input: $input) {
      csv
      errorJson
    }
  }
}
    `) as unknown as TypedDocumentString<ComplianceCsvQuery, ComplianceCsvQueryVariables>;
export const ComplianceReviewCreativeDocument = new TypedDocumentString(`
    query ComplianceReviewCreative($complianceCodeId: String!, $creativeId: String!) {
  compliance {
    creative(input: {complianceCodeId: $complianceCodeId, creativeId: $creativeId}) {
      creativeId
      teamId
      complianceCodeId
      progressStatus
      notes
      shortlists
      history {
        summary
        actor
        timestamp
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      creative {
        id
        creative
        firstAppeared
        lastAppeared
        status
        mediaTypeList {
          id
          name
          canonicalName
        }
        mediaOwnerList {
          id
          name
        }
        publisherList {
          id
          name
        }
        publicationList {
          id
          name
        }
        regionList {
          id
          name
        }
        country
        placementTypes
        advertiserDomain
        aiExtractedTextV1
        aiTranscriptionTextV1
        aiAdTypeV1
        aiCampaignHeadlineV1
        compliance {
          compliance_code
          compliance_code_id
          compliance_risk_rating
          compliance_reason
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ComplianceReviewCreativeQuery, ComplianceReviewCreativeQueryVariables>;
export const ComplianceUpdateCreativeDocument = new TypedDocumentString(`
    mutation ComplianceUpdateCreative($input: ComplianceCreativeUpdateMutationInput!) {
  compliance {
    updateComplianceCreative(input: $input) {
      creativeId
      teamId
      complianceCodeId
      progressStatus
      notes
      shortlists
      history {
        summary
        actor
        timestamp
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
}
    `) as unknown as TypedDocumentString<ComplianceUpdateCreativeMutation, ComplianceUpdateCreativeMutationVariables>;
export const CreativeItemV2Document = new TypedDocumentString(`
    query CreativeItemV2($creativeId: ID!) {
  creativeV2 {
    publicCreativeItemV2(creativeId: $creativeId) {
      id
      creative
      firstAppeared
      lastAppeared
      status
      mediaOwnerList {
        id
        name
      }
      mediaTypeList {
        id
        name
        canonicalName
      }
      publisherList {
        id
        name
      }
      publicationList {
        id
        name
      }
      regionList {
        id
        name
      }
      country
      placementTypes
      advertiserDomain
      aiExtractedTextV1
      aiTranscriptionTextV1
      aiAdTypeV1
      aiDemographicsV1 {
        genderDistribution {
          unspecified
          female
          male
        }
        ageBracket
        ageName
      }
      aiSummaryInsightsV1 {
        summary150
        summary300
      }
      aiTagsV1 {
        advertiser
        industry
        category
        product
        fuelType
      }
      compliance {
        compliance_code
        compliance_code_id
        compliance_risk_rating
        compliance_reason
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeItemV2Query, CreativeItemV2QueryVariables>;
export const ComplianceCreativeItemV2Document = new TypedDocumentString(`
    query ComplianceCreativeItemV2($creativeId: ID!) {
  creativeV2 {
    publicCreativeItemV2(creativeId: $creativeId) {
      id
      creative
      firstAppeared
      lastAppeared
      status
      mediaOwnerList {
        id
        name
      }
      mediaTypeList {
        id
        name
        canonicalName
      }
      publisherList {
        id
        name
      }
      publicationList {
        id
        name
      }
      regionList {
        id
        name
      }
      country
      placementTypes
      advertiserDomain
      aiExtractedTextV1
      aiTranscriptionTextV1
      aiAdTypeV1
      aiDemographicsV1 {
        genderDistribution {
          unspecified
          female
          male
        }
        ageBracket
        ageName
      }
      aiSummaryInsightsV1 {
        summary150
        summary300
      }
      aiTagsV1 {
        advertiser
        industry
        category
        product
        fuelType
      }
      compliance {
        compliance_code
        compliance_code_id
        compliance_risk_rating
        compliance_reason
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ComplianceCreativeItemV2Query, ComplianceCreativeItemV2QueryVariables>;
export const CreativeListV2Document = new TypedDocumentString(`
    query CreativeListV2($input: CreativeListInputV2!) {
  creativeV2 {
    creativeListV2(input: $input) {
      totalCount
      paginationInfo {
        hasPreviousPage
        hasNextPage
        currentPage
      }
      items {
        id
        creative
        firstAppeared
        lastAppeared
        status
        mediaTypeList {
          id
          name
          canonicalName
        }
        mediaOwnerList {
          id
          name
        }
        publisherList {
          id
          name
        }
        publicationList {
          id
          name
        }
        regionList {
          id
          name
        }
        country
        placementTypes
        advertiserDomain
        aiExtractedTextV1
        aiTranscriptionTextV1
        aiAdTypeV1
        aiCampaignHeadlineV1
        aiDemographicsV1 {
          genderDistribution {
            unspecified
            female
            male
          }
          ageBracket
          ageName
        }
        aiSummaryInsightsV1 {
          summary150
          summary300
        }
        aiTagsV1 {
          advertiser
          industry
          category
          product
          fuelType
        }
        compliance {
          compliance_code
          compliance_code_id
          compliance_risk_rating
          compliance_reason
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeListV2Query, CreativeListV2QueryVariables>;
export const CreativeDownloadDocument = new TypedDocumentString(`
    query CreativeDownload($input: CreativeDownloadInput!) {
  creativeV2 {
    creativeDownload(input: $input) {
      downloadLink
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeDownloadQuery, CreativeDownloadQueryVariables>;
export const CreativeMediaValueDocument = new TypedDocumentString(`
    query CreativeMediaValue($input: CreativeMediaValueInput!) {
  creativeV2 {
    creativeMediaValue(input: $input) {
      date
      normalizedSpend
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeMediaValueQuery, CreativeMediaValueQueryVariables>;
export const GroupByCampaignDocument = new TypedDocumentString(`
    query GroupByCampaign($input: GroupByCampaignInput!) {
  creativeV2 {
    groupByCampaign(input: $input) {
      items {
        campaignName
        creativeCount
        thumbnailCreative
        status
        firstAppeared
        lastAppeared
        region
        mediaType
        publication
        publisher
        mediaOwner
        aiAdType
        aiProducts
        aiCategories
        aiIndustries
        aiAdvertisers
        country
      }
      paginationInfo {
        afterKey
        nextPageMayContainMoreCampaigns
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GroupByCampaignQuery, GroupByCampaignQueryVariables>;
export const FilterQueryDocument = new TypedDocumentString(`
    query FilterQuery($input: FilterInputV2!, $filter: FilterForFilteringFiltersV2, $options: FilterOptions) {
  filterV2 {
    filters(input: $input, filter: $filter, options: $options) {
      column
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
      }
      items {
        advertiserDomain {
          id
          name
        }
        publication {
          id
          name
        }
        publisher {
          id
          name
        }
        region {
          id
          name
        }
        mediaOwner {
          id
          name
        }
        mediaType {
          id
          name
          canonicalName
        }
        changeset {
          id
          name
          status
        }
        segment {
          id
          name
          color
          emailAlert
          teamId
          createdAt
          updatedAt
          sharing {
            status
            usersWithAccess {
              id
              name
              email
            }
          }
          author {
            id
            name
            email
          }
        }
        status {
          id
          name
        }
        placementType {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FilterQueryQuery, FilterQueryQueryVariables>;
export const CreativeAiFiltersDocument = new TypedDocumentString(`
    query CreativeAiFilters($input: FilterAiInputV2!, $filter: AiFilters) {
  aiEntities {
    filterAiEntitiesV2(input: $input, filter: $filter) {
      column
      pageInfo {
        nextOffset
        hasNextPage
      }
      items {
        aiAdvertiserV1 {
          name
          hasAccess
        }
        aiCategoryV1 {
          name
          hasAccess
        }
        aiIndustryV1 {
          name
          hasAccess
        }
        aiProductV1 {
          name
          hasAccess
        }
        aiFuelTypeV1 {
          name
          hasAccess
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeAiFiltersQuery, CreativeAiFiltersQueryVariables>;
export const MediaValueAiFiltersDocument = new TypedDocumentString(`
    query MediaValueAiFilters($input: MediaValueFilterInput!, $filter: MediaValueFilters) {
  mediaValueEntities {
    filterMediaValueEntities(input: $input, filter: $filter) {
      column
      pageInfo {
        nextOffset
        hasNextPage
      }
      items {
        aiAdvertiserV1 {
          name
          hasAccess
        }
        aiCategoryV1 {
          name
          hasAccess
        }
        aiIndustryV1 {
          name
          hasAccess
        }
        aiProductV1 {
          name
          hasAccess
        }
        aiFuelTypeV1 {
          name
          hasAccess
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MediaValueAiFiltersQuery, MediaValueAiFiltersQueryVariables>;
export const GetEntitiesByIdDocument = new TypedDocumentString(`
    query GetEntitiesById($input: GetEntitiesByIdInput!) {
  filterV2 {
    getEntitiesById(input: $input) {
      adType {
        id
        name
        canonicalName
      }
      brand {
        id
        name
        industries {
          id
          name
        }
      }
      industry {
        id
        name
      }
      category {
        id
        name
        industry {
          id
          name
        }
      }
      campaign {
        id
        name
      }
      publisher {
        id
        name
      }
      publication {
        id
        name
      }
      region {
        id
        name
      }
      product {
        id
        name
        brand {
          id
          name
        }
      }
      mediaOwner {
        id
        name
      }
      mediaType {
        id
        name
        canonicalName
      }
      changeset {
        id
        name
        status
      }
      segment {
        id
        name
        color
        emailAlert
        teamId
        createdAt
        updatedAt
        sharing {
          status
          usersWithAccess {
            id
            name
            email
          }
        }
        author {
          id
          name
          email
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetEntitiesByIdQuery, GetEntitiesByIdQueryVariables>;
export const ConvertNamesToEntitiesDocument = new TypedDocumentString(`
    query ConvertNamesToEntities($input: ConvertNameToEntitiesInput!) {
  filterV2 {
    convertNamesToEntities(input: $input) {
      adType {
        id
        name
        canonicalName
      }
      brand {
        id
        name
      }
      industry {
        id
        name
      }
      mediaType {
        id
        name
        canonicalName
      }
      region {
        id
        name
      }
      publisher {
        id
        name
      }
      publication {
        id
        name
      }
      mediaOwner {
        id
        name
      }
      mediaTypeSynonym {
        id
        name
        canonicalName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ConvertNamesToEntitiesQuery, ConvertNamesToEntitiesQueryVariables>;
export const ConvertNameFiltersToIdsDocument = new TypedDocumentString(`
    query ConvertNameFiltersToIds($input: ConvertFiltersInput!) {
  filterV2 {
    convertNameFiltersToIds(input: $input) {
      adType
      brand
      category
      industry
      mediaType
      product
      region
    }
  }
}
    `) as unknown as TypedDocumentString<ConvertNameFiltersToIdsQuery, ConvertNameFiltersToIdsQueryVariables>;
export const GmvFilterQueryDocument = new TypedDocumentString(`
    query gmvFilterQuery($country: SupportedCountry!, $column: GlobalMediaValueInputColumn!, $searchText: String, $filter: GlobalMediaValueColumnFilter, $size: Int, $after: String, $restrictedItemDisplayType: GlobalMediaValueRestrictedtemDisplayType) {
  globalMediaValue {
    filterQuery(
      country: $country
      column: $column
      searchText: $searchText
      filter: $filter
      size: $size
      after: $after
      restrictedItemDisplayType: $restrictedItemDisplayType
    ) {
      items {
        column
        value
        isLocked
      }
      after
    }
  }
}
    `) as unknown as TypedDocumentString<GmvFilterQueryQuery, GmvFilterQueryQueryVariables>;
export const MediaValueRowsV3Document = new TypedDocumentString(`
    query MediaValueRowsV3($columns: [MediaValueInputColumn!], $columnFilter: MediaValueColumnFilter, $excludeFilter: MediaValueExcludeList, $dateRangeFilter: MediaValueDateRangeFilter, $pagination: MediaValuePagination, $changesetId: Int, $adType: Boolean!, $brand: Boolean!, $campaign: Boolean!, $category: Boolean!, $industry: Boolean!, $mediaOwner: Boolean!, $mediaType: Boolean!, $product: Boolean!, $publisher: Boolean!, $region: Boolean!, $segment: Boolean!, $publication: Boolean!, $fuelType: Boolean!) {
  mediaValue {
    rowsV3(
      columns: $columns
      columnFilter: $columnFilter
      dateRangeFilter: $dateRangeFilter
      pagination: $pagination
      excludeList: $excludeFilter
      changesetId: $changesetId
    ) {
      rows {
        date
        value
        adType @include(if: $adType)
        brand @include(if: $brand)
        campaign @include(if: $campaign)
        category @include(if: $category)
        industry @include(if: $industry)
        mediaOwner @include(if: $mediaOwner)
        mediaType @include(if: $mediaType)
        product @include(if: $product)
        publisher @include(if: $publisher)
        region @include(if: $region)
        segment @include(if: $segment)
        publication @include(if: $publication)
        fuelType @include(if: $fuelType)
      }
      labels {
        segment @include(if: $segment) {
          id
          name
          color
        }
      }
      columnTotals {
        column
        value
      }
      grandTotal
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
      }
      meta {
        isTruncated
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MediaValueRowsV3Query, MediaValueRowsV3QueryVariables>;
export const MediaValueCsvV3Document = new TypedDocumentString(`
    query MediaValueCsvV3($columns: [MediaValueInputColumn!], $columnFilter: MediaValueColumnFilter, $dateRangeFilter: MediaValueDateRangeFilter, $csvFileName: String, $pagination: MediaValuePagination, $changesetId: Int, $includePercentage: Boolean, $includeDollarFigureForSOVReports: Boolean) {
  mediaValue {
    csvV3(
      columns: $columns
      columnFilter: $columnFilter
      dateRangeFilter: $dateRangeFilter
      csvFileName: $csvFileName
      pagination: $pagination
      changesetId: $changesetId
      includePercentage: $includePercentage
      includeDollarFigureForSOVReports: $includeDollarFigureForSOVReports
    ) {
      csv
    }
  }
}
    `) as unknown as TypedDocumentString<MediaValueCsvV3Query, MediaValueCsvV3QueryVariables>;
export const GmvExpenditureReportCsvExportDocument = new TypedDocumentString(`
    query gmvExpenditureReportCSVExport($columns: [GlobalMediaValueInputColumn!], $columnFilter: GlobalMediaValueColumnFilter, $dateRangeFilter: GlobalMediaValueDateRangeFilter, $csvFileName: String, $pagination: GlobalMediaValuePagination, $country: SupportedCountry!, $includePercentage: Boolean, $includeDollarFigureForSOVReports: Boolean) {
  globalMediaValue {
    csv(
      country: $country
      columns: $columns
      columnFilter: $columnFilter
      dateRangeFilter: $dateRangeFilter
      csvFileName: $csvFileName
      pagination: $pagination
      includePercentage: $includePercentage
      includeDollarFigureForSOVReports: $includeDollarFigureForSOVReports
    ) {
      csv
    }
  }
}
    `) as unknown as TypedDocumentString<GmvExpenditureReportCsvExportQuery, GmvExpenditureReportCsvExportQueryVariables>;
export const DistributionV3Document = new TypedDocumentString(`
    query DistributionV3($dateRangeFilter: MediaValueDateRangeFilter!, $breakdownColumn: MediaValueBreakdownColumn!, $rows: [MediaValueRowFilterInput!]!) {
  mediaValue {
    distributionV3(
      dateRangeFilter: $dateRangeFilter
      breakdownColumn: $breakdownColumn
      rows: $rows
    ) {
      rows
      columnMeta
    }
  }
}
    `) as unknown as TypedDocumentString<DistributionV3Query, DistributionV3QueryVariables>;
export const GmvDistributionDocument = new TypedDocumentString(`
    query gmvDistribution($dateRangeFilter: GlobalMediaValueDateRangeFilter!, $breakdownColumn: GlobalMediaValueBreakdownColumn!, $rows: [GlobalMediaValueRowFilterInput!]!, $country: SupportedCountry!) {
  globalMediaValue {
    distribution(
      country: $country
      dateRangeFilter: $dateRangeFilter
      breakdownColumn: $breakdownColumn
      rows: $rows
    ) {
      rows
      columnMeta
    }
  }
}
    `) as unknown as TypedDocumentString<GmvDistributionQuery, GmvDistributionQueryVariables>;
export const ComparisonV3Document = new TypedDocumentString(`
    query ComparisonV3($periodSelection: PeriodSelection!, $rows: [MediaValueRowFilterInput!]!) {
  mediaValue {
    comparisonV3(periodSelection: $periodSelection, rows: $rows) {
      rows
      columnMeta
    }
  }
}
    `) as unknown as TypedDocumentString<ComparisonV3Query, ComparisonV3QueryVariables>;
export const GmvComparisonDocument = new TypedDocumentString(`
    query gmvComparison($periodSelection: GlobalMediaValuePeriodSelection!, $rows: [GlobalMediaValueRowFilterInput!]!, $country: SupportedCountry!) {
  globalMediaValue {
    comparison(periodSelection: $periodSelection, rows: $rows, country: $country) {
      rows
      columnMeta
    }
  }
}
    `) as unknown as TypedDocumentString<GmvComparisonQuery, GmvComparisonQueryVariables>;
export const GetForecastDatesDocument = new TypedDocumentString(`
    query GetForecastDates($queryOpensearch: Boolean) {
  mediaValue {
    getForecastDates(queryOpensearch: $queryOpensearch) {
      forecastCutoff
      forecastCutoffDigital
      maxDate
    }
  }
}
    `) as unknown as TypedDocumentString<GetForecastDatesQuery, GetForecastDatesQueryVariables>;
export const GmvStatsQueryDocument = new TypedDocumentString(`
    query gmvStatsQuery($country: SupportedCountry!) {
  globalMediaValue {
    stats(country: $country) {
      latestDate
    }
  }
}
    `) as unknown as TypedDocumentString<GmvStatsQueryQuery, GmvStatsQueryQueryVariables>;
export const GmvExpenditureReportDocument = new TypedDocumentString(`
    query gmvExpenditureReport($country: SupportedCountry!, $columns: [GlobalMediaValueInputColumn!], $columnFilter: GlobalMediaValueColumnFilter, $excludeFilter: GlobalMediaValueExcludeList, $dateRangeFilter: GlobalMediaValueDateRangeFilter, $pagination: GlobalMediaValuePagination, $includeColumnTotals: Boolean!, $adType: Boolean!, $brand: Boolean!, $category: Boolean!, $industry: Boolean!, $mediaType: Boolean!, $product: Boolean!, $publication: Boolean!, $region: Boolean!, $fuelType: Boolean!) {
  globalMediaValue {
    expenditureReport(
      country: $country
      columnFilter: $columnFilter
      columns: $columns
      dateRangeFilter: $dateRangeFilter
      excludeList: $excludeFilter
      pagination: $pagination
      includeColumnTotals: $includeColumnTotals
    ) {
      cells {
        date
        value
        adType @include(if: $adType)
        brand @include(if: $brand)
        category @include(if: $category)
        industry @include(if: $industry)
        mediaType @include(if: $mediaType)
        product @include(if: $product)
        publication @include(if: $publication)
        region @include(if: $region)
        fuelType @include(if: $fuelType)
      }
      columnTotals @include(if: $includeColumnTotals) {
        column
        value
      }
      grandTotal @include(if: $includeColumnTotals)
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
      }
      meta {
        isTruncated
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GmvExpenditureReportQuery, GmvExpenditureReportQueryVariables>;
export const ReportQueryDocument = new TypedDocumentString(`
    query ReportQuery($id: UUID!) {
  reportV2 {
    report(id: $id) {
      id
      status
      user {
        id
        name
      }
      teamId
      teamName
      name
      description
      createdAt
      updatedAt
      items {
        id
        name
        type
        description
        definitionV2
        teamId
        createdAt
        status
        updateAt
        userId
      }
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      iconName
      iconColor
      country
    }
  }
}
    `) as unknown as TypedDocumentString<ReportQueryQuery, ReportQueryQueryVariables>;
export const ReportCreateDocument = new TypedDocumentString(`
    mutation ReportCreate($input: ReportCreateInput!) {
  reportV2 {
    reportCreate(input: $input) {
      id
      user {
        id
        name
      }
      teamId
      teamName
      name
      description
      createdAt
      updatedAt
      items {
        id
      }
      iconName
      iconColor
      country
      status
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ReportCreateMutation, ReportCreateMutationVariables>;
export const ReportUpdateDocument = new TypedDocumentString(`
    mutation ReportUpdate($input: ReportUpdateInput!) {
  reportV2 {
    reportUpdate(input: $input) {
      id
      user {
        id
        name
      }
      teamId
      teamName
      name
      description
      createdAt
      updatedAt
      items {
        id
        userId
        teamId
        type
        definitionV2
        createdAt
        updateAt
        status
        name
        description
      }
      iconName
      iconColor
      sharing {
        status
        usersWithAccess {
          name
          id
          email
        }
      }
      status
      country
    }
  }
}
    `) as unknown as TypedDocumentString<ReportUpdateMutation, ReportUpdateMutationVariables>;
export const ReportRemoveDocument = new TypedDocumentString(`
    mutation ReportRemove($id: UUID!) {
  reportV2 {
    reportRemove(id: $id)
  }
}
    `) as unknown as TypedDocumentString<ReportRemoveMutation, ReportRemoveMutationVariables>;
export const ReportDuplicateDocument = new TypedDocumentString(`
    mutation ReportDuplicate($id: UUID!) {
  reportV2 {
    reportDuplicate(id: $id) {
      id
      user {
        id
        name
      }
      teamId
      teamName
      name
      description
      createdAt
      updatedAt
      items {
        id
        userId
        teamId
        type
        definitionV2
        createdAt
        updateAt
        status
        name
        description
      }
      iconName
      iconColor
      sharing {
        status
        usersWithAccess {
          name
          id
          email
        }
      }
      status
      country
    }
  }
}
    `) as unknown as TypedDocumentString<ReportDuplicateMutation, ReportDuplicateMutationVariables>;
export const ReportListV3QueryDocument = new TypedDocumentString(`
    query ReportListV3Query($input: ReportListInput!) {
  reportV3 {
    reportList(input: $input) {
      items {
        id
        user {
          id
          name
        }
        teamId
        status
        teamName
        name
        description
        iconName
        iconColor
        sharing {
          status
          usersWithAccess {
            id
            name
            email
          }
        }
        createdAt
        updatedAt
        country
      }
      pagination {
        page
        count
        hasNextPage
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ReportListV3QueryQuery, ReportListV3QueryQueryVariables>;
export const ReportRemoveManyDocument = new TypedDocumentString(`
    mutation ReportRemoveMany($ids: [UUID!]!) {
  reportV2 {
    reportRemoveMany(ids: $ids) {
      id
      user {
        id
        name
      }
      teamId
      teamName
      name
      description
      createdAt
      updatedAt
      iconName
      iconColor
      status
      sharing {
        status
        usersWithAccess {
          name
          id
          email
        }
      }
      country
    }
  }
}
    `) as unknown as TypedDocumentString<ReportRemoveManyMutation, ReportRemoveManyMutationVariables>;
export const ReportShareManyDocument = new TypedDocumentString(`
    mutation ReportShareMany($input: ReportShareManyInput!) {
  reportV2 {
    reportShareMany(input: $input) {
      id
      user {
        id
        name
      }
      teamId
      teamName
      name
      description
      createdAt
      updatedAt
      iconName
      iconColor
      status
      sharing {
        status
        usersWithAccess {
          name
          id
          email
        }
      }
      country
    }
  }
}
    `) as unknown as TypedDocumentString<ReportShareManyMutation, ReportShareManyMutationVariables>;
export const ReportSearchDocument = new TypedDocumentString(`
    query ReportSearch($input: ReportSearchInput!) {
  reportV2 {
    reportSearch(input: $input) {
      id
      user {
        id
        name
      }
      teamId
      teamName
      name
      description
      iconName
      iconColor
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      createdAt
      updatedAt
      status
      country
    }
  }
}
    `) as unknown as TypedDocumentString<ReportSearchQuery, ReportSearchQueryVariables>;
export const ReportItemCreateDocument = new TypedDocumentString(`
    mutation ReportItemCreate($input: ReportItemV2CreateInput!) {
  reportV2 {
    reportItemCreate(input: $input) {
      id
      userId
      teamId
      type
      definitionV2
      createdAt
      updateAt
      status
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<ReportItemCreateMutation, ReportItemCreateMutationVariables>;
export const ReportItemRemoveDocument = new TypedDocumentString(`
    mutation ReportItemRemove($input: ReportItemRemoveInput!) {
  reportV2 {
    reportItemRemove(input: $input)
  }
}
    `) as unknown as TypedDocumentString<ReportItemRemoveMutation, ReportItemRemoveMutationVariables>;
export const ReportItemUpdateDocument = new TypedDocumentString(`
    mutation ReportItemUpdate($input: ReportItemV2UpdateInput!) {
  reportV2 {
    reportItemUpdate(input: $input) {
      id
      userId
      teamId
      type
      definitionV2
      createdAt
      updateAt
      status
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<ReportItemUpdateMutation, ReportItemUpdateMutationVariables>;
export const PdfReportCreateMutationDocument = new TypedDocumentString(`
    mutation PdfReportCreateMutation($reportId: UUID!, $timezone: String, $printConfig: String) {
  pdfRenderer {
    pdfReportCreate(
      input: {reportId: $reportId, timezone: $timezone, printConfig: $printConfig, debug: true}
    ) {
      downloadLink
    }
  }
}
    `) as unknown as TypedDocumentString<PdfReportCreateMutationMutation, PdfReportCreateMutationMutationVariables>;
export const PdfCreativeProfileMutationDocument = new TypedDocumentString(`
    mutation PdfCreativeProfileMutation($filter: String!, $appUrl: String!, $timezone: String!, $printConfig: String) {
  pdfRenderer {
    pdfCreative(
      input: {timezone: $timezone, filter: $filter, appUrl: $appUrl, printConfig: $printConfig, debug: true}
    ) {
      downloadLink
    }
  }
}
    `) as unknown as TypedDocumentString<PdfCreativeProfileMutationMutation, PdfCreativeProfileMutationMutationVariables>;
export const SearchDocument = new TypedDocumentString(`
    query Search($search: SearchInputV2!) {
  searchV2 {
    search(search: $search) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
      }
      items {
        name
        type
        id
        industries {
          id
          name
          type
        }
        hasAccess
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchQuery, SearchQueryVariables>;
export const OnboardingSearchDocument = new TypedDocumentString(`
    query OnboardingSearch($search: OnboardingSearchInput!) {
  searchV2 {
    onboardingSearch(search: $search) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
      }
      items {
        name
        type
        id
        industries {
          id
          name
          type
        }
        hasAccess
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OnboardingSearchQuery, OnboardingSearchQueryVariables>;
export const CreativeEmailSegmentCreateDocument = new TypedDocumentString(`
    mutation CreativeEmailSegmentCreate($input: SegmentV2CreateInput!) {
  segmentV2 {
    segmentCreate(input: $input) {
      id
      name
      color
      teamId
      teamName
      description
      definitionV2
      emailAlert
      author {
        id
        name
        email
      }
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      createdAt
      updatedAt
      status
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeEmailSegmentCreateMutation, CreativeEmailSegmentCreateMutationVariables>;
export const CreativeEmailSegmentUpdateDocument = new TypedDocumentString(`
    mutation CreativeEmailSegmentUpdate($input: CreativeEmailSegmentUpdateInput!) {
  segmentV2 {
    creativeEmailSegmentUpdate(input: $input) {
      id
      name
      color
      teamId
      description
      definitionV2
      emailAlert
      author {
        id
        name
        email
      }
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      createdAt
      updatedAt
      status
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeEmailSegmentUpdateMutation, CreativeEmailSegmentUpdateMutationVariables>;
export const CreativeEmailSegmentQueryDocument = new TypedDocumentString(`
    query CreativeEmailSegmentQuery($input: CreativeEmailSegmentInput) {
  segmentV2 {
    creativeEmailSegment(input: $input) {
      id
      name
      color
      teamId
      description
      definitionV2
      emailAlert
      author {
        id
        name
        email
      }
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      createdAt
      updatedAt
      status
    }
  }
}
    `) as unknown as TypedDocumentString<CreativeEmailSegmentQueryQuery, CreativeEmailSegmentQueryQueryVariables>;
export const SegmentCreateMutationDocument = new TypedDocumentString(`
    mutation SegmentCreateMutation($input: SegmentV2CreateInput!) {
  segmentV2 {
    segmentCreate(input: $input) {
      id
      name
      color
      teamId
      teamName
      description
      definitionV2
      author {
        id
        name
        email
      }
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      createdAt
      updatedAt
      status
      emailAlert
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentCreateMutationMutation, SegmentCreateMutationMutationVariables>;
export const SegmentListQueryDocument = new TypedDocumentString(`
    query SegmentListQuery($input: SegmentListOptions) {
  segmentV2 {
    segmentList(input: $input) {
      data {
        id
        name
        color
        teamId
        teamName
        description
        definitionV2
        emailAlert
        author {
          id
          name
          email
        }
        sharing {
          status
          usersWithAccess {
            id
            name
            email
          }
        }
        createdAt
        updatedAt
        status
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentListQueryQuery, SegmentListQueryQueryVariables>;
export const SegmentUpdateMutationDocument = new TypedDocumentString(`
    mutation SegmentUpdateMutation($input: SegmentV2UpdateInput!) {
  segmentV2 {
    segmentUpdate(input: $input) {
      id
      name
      color
      teamId
      teamName
      description
      definitionV2
      emailAlert
      author {
        id
        name
        email
      }
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      createdAt
      updatedAt
      status
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentUpdateMutationMutation, SegmentUpdateMutationMutationVariables>;
export const SegmentRemoveMutationDocument = new TypedDocumentString(`
    mutation SegmentRemoveMutation($id: UUID!) {
  segmentV2 {
    segmentRemove(id: $id)
  }
}
    `) as unknown as TypedDocumentString<SegmentRemoveMutationMutation, SegmentRemoveMutationMutationVariables>;
export const SegmentV2QueryDocument = new TypedDocumentString(`
    query SegmentV2Query($id: UUID!, $includeDeleted: Boolean, $ignoreSharing: Boolean) {
  segmentV2 {
    segment(id: $id, includeDeleted: $includeDeleted, ignoreSharing: $ignoreSharing) {
      id
      name
      color
      teamId
      teamName
      description
      definitionV2
      emailAlert
      author {
        id
        name
        email
      }
      sharing {
        status
        usersWithAccess {
          id
          name
          email
        }
      }
      createdAt
      updatedAt
      status
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentV2QueryQuery, SegmentV2QueryQueryVariables>;
export const SegmentRemoveManyDocument = new TypedDocumentString(`
    mutation SegmentRemoveMany($ids: [UUID!]!) {
  segmentV2 {
    segmentRemoveMany(ids: $ids) {
      data {
        id
        name
        color
        description
        author {
          name
          id
        }
        teamId
        teamName
        sharing {
          status
          usersWithAccess {
            id
            name
          }
        }
        createdAt
        updatedAt
        status
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentRemoveManyMutation, SegmentRemoveManyMutationVariables>;
export const SegmentShareManyDocument = new TypedDocumentString(`
    mutation SegmentShareMany($input: SegmentV2ShareManyInput!) {
  segmentV2 {
    segmentShareMany(input: $input) {
      data {
        id
        name
        color
        description
        author {
          name
          id
        }
        teamId
        teamName
        sharing {
          status
          usersWithAccess {
            id
            name
          }
        }
        createdAt
        updatedAt
        status
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentShareManyMutation, SegmentShareManyMutationVariables>;
export const SegmentSearchQueryDocument = new TypedDocumentString(`
    query SegmentSearchQuery($input: SegmentSearchInput!) {
  segmentV2 {
    segmentSearch(input: $input) {
      data {
        id
        name
        color
        description
        author {
          name
          id
          email
        }
        teamId
        teamName
        sharing {
          status
          usersWithAccess {
            id
            name
            email
          }
        }
        createdAt
        updatedAt
        status
        emailAlert
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentSearchQueryQuery, SegmentSearchQueryQueryVariables>;
export const SegmentNzUnsubsribeMutationDocument = new TypedDocumentString(`
    mutation SegmentNzUnsubsribeMutation($teamId: UUID!) {
  segmentV2 {
    nzUnsubscribe(teamId: $teamId)
  }
}
    `) as unknown as TypedDocumentString<SegmentNzUnsubsribeMutationMutation, SegmentNzUnsubsribeMutationMutationVariables>;
export const TeamIncrementDownloadCountMutationDocument = new TypedDocumentString(`
    mutation TeamIncrementDownloadCountMutation($teamId: UUID!) {
  team {
    teamIncrementDownloadCount(mutation: {id: $teamId}) {
      id
      metadata
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<TeamIncrementDownloadCountMutationMutation, TeamIncrementDownloadCountMutationMutationVariables>;
export const TeamItemQueryDocument = new TypedDocumentString(`
    query TeamItemQuery($teamId: UUID!) {
  team {
    team(teamId: $teamId) {
      id
      name
      members {
        teamId
        userId
        user {
          id
          username
          name
        }
        role
        createdAt
        updatedAt
      }
      products {
        product
        industryIds
        mediaTypeIds
        status
        metadata
        country
        compliance {
          AU {
            AANA_CODE_OF_ETHICS
            AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE
            AANA_CHILDRENS_ADVERTISING_CODE
            AANA_ENVIRONMENTAL_CLAIMS_CODE
            AANA_WAGERING_ADVERTISING_CODE
            FCAI_CODE
            TGA_CODE
            ABAC_CODE
          }
        }
      }
      invites(status: [PENDING]) {
        id
        username
        role
        status
        createdAt
        team {
          id
        }
        inviter {
          id
        }
      }
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<TeamItemQueryQuery, TeamItemQueryQueryVariables>;
export const TeamCreateWithInviteDocument = new TypedDocumentString(`
    mutation teamCreateWithInvite($teamName: String!, $email: String!, $inviterId: String!) {
  team {
    teamCreateWithInvite(
      mutation: {teamName: $teamName, email: $email, inviterId: $inviterId}
    ) {
      id
      name
      status
      invites(status: [PENDING]) {
        id
        username
        role
        status
        createdAt
      }
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<TeamCreateWithInviteMutation, TeamCreateWithInviteMutationVariables>;
export const TeamInviteResendMutationDocument = new TypedDocumentString(`
    mutation teamInviteResendMutation($inviteId: UUID!) {
  team {
    teamResendInvite(mutation: {inviteId: $inviteId})
  }
}
    `) as unknown as TypedDocumentString<TeamInviteResendMutationMutation, TeamInviteResendMutationMutationVariables>;
export const TeamRemoveInviteMutationDocument = new TypedDocumentString(`
    mutation teamRemoveInviteMutation($inviteId: UUID!) {
  team {
    teamRemoveInvite(mutation: {inviteId: $inviteId})
  }
}
    `) as unknown as TypedDocumentString<TeamRemoveInviteMutationMutation, TeamRemoveInviteMutationMutationVariables>;
export const TeamMemberRemoveMutationDocument = new TypedDocumentString(`
    mutation TeamMemberRemoveMutation($userId: String!, $teamId: UUID!) {
  team {
    teamRemoveUser(mutation: {userId: $userId, teamId: $teamId})
  }
}
    `) as unknown as TypedDocumentString<TeamMemberRemoveMutationMutation, TeamMemberRemoveMutationMutationVariables>;
export const TeamMemberUpdateMutationDocument = new TypedDocumentString(`
    mutation TeamMemberUpdateMutation($id: UUID!, $userId: String!, $role: TeamMemberRole!) {
  team {
    teamUpdateUser(mutation: {teamId: $id, userId: $userId, role: $role}) {
      teamId
      userId
      role
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<TeamMemberUpdateMutationMutation, TeamMemberUpdateMutationMutationVariables>;
export const TeamResetDownloadCountMutationDocument = new TypedDocumentString(`
    mutation TeamResetDownloadCountMutation($teamId: UUID!) {
  team {
    teamResetDownloadCount(mutation: {id: $teamId}) {
      id
      metadata
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<TeamResetDownloadCountMutationMutation, TeamResetDownloadCountMutationMutationVariables>;
export const TeamMemberAddMutationDocument = new TypedDocumentString(`
    mutation TeamMemberAddMutation($member: AddUserToTeamInput!) {
  team {
    teamAddUser(mutation: $member) {
      userId
      teamId
      role
      status
      createdAt
      team {
        id
        members {
          userId
          user {
            id
            username
            name
          }
          role
          status
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TeamMemberAddMutationMutation, TeamMemberAddMutationMutationVariables>;
export const TeamMemberInviteMutationDocument = new TypedDocumentString(`
    mutation TeamMemberInviteMutation($invite: InviteUserToTeamInput!) {
  team {
    teamInviteUser(mutation: $invite) {
      id
      username
      role
      status
      createdAt
      team {
        id
        members {
          userId
          user {
            id
            username
            name
          }
          role
          status
          createdAt
          updatedAt
        }
        invites(status: [PENDING]) {
          id
          username
          role
          status
          createdAt
          inviter {
            id
          }
        }
      }
      inviter {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TeamMemberInviteMutationMutation, TeamMemberInviteMutationMutationVariables>;
export const RemoveTeamDocument = new TypedDocumentString(`
    mutation removeTeam($teamId: UUID!) {
  team {
    teamRemove(mutation: {teamId: $teamId})
  }
}
    `) as unknown as TypedDocumentString<RemoveTeamMutation, RemoveTeamMutationVariables>;
export const TeamUpdateDocument = new TypedDocumentString(`
    mutation TeamUpdate($id: UUID!, $name: String!) {
  team {
    teamUpdate(mutation: {id: $id, name: $name}) {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<TeamUpdateMutation, TeamUpdateMutationVariables>;
export const TeamUpdateProductsDocument = new TypedDocumentString(`
    mutation TeamUpdateProducts($id: UUID!, $products: [TeamProductInput!]!) {
  team {
    teamUpdateProducts(mutation: {teamId: $id, teamProducts: $products}) {
      product
      industryIds
      mediaTypeIds
      status
      metadata
      country
      compliance {
        AU {
          AANA_CODE_OF_ETHICS
          AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE
          AANA_CHILDRENS_ADVERTISING_CODE
          AANA_ENVIRONMENTAL_CLAIMS_CODE
          AANA_WAGERING_ADVERTISING_CODE
          FCAI_CODE
          TGA_CODE
          ABAC_CODE
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TeamUpdateProductsMutation, TeamUpdateProductsMutationVariables>;
export const TeamListQueryDocument = new TypedDocumentString(`
    query TeamListQuery($search: String, $status: TeamProductStatusFilter, $country: String, $industryList: [String!]) {
  team {
    teamList(
      search: $search
      status: $status
      country: $country
      industryList: $industryList
    ) {
      id
      name
      status
      createdAt
      updatedAt
      members {
        teamId
        userId
      }
      products {
        product
        status
        industryIds
        metadata
        country
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TeamListQueryQuery, TeamListQueryQueryVariables>;
export const TeamAddNzTrialDocument = new TypedDocumentString(`
    mutation TeamAddNzTrial($input: AddNzTrialInput!) {
  team {
    teamAddNzTrial(mutation: $input) {
      id
      name
      status
      createdAt
      updatedAt
      metadata
      members {
        teamId
        userId
        user {
          username
          id
        }
      }
      products {
        product
        status
        industryIds
        metadata
        country
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TeamAddNzTrialMutation, TeamAddNzTrialMutationVariables>;
export const SubmitFormDocument = new TypedDocumentString(`
    mutation SubmitForm($formId: String!, $formInput: [TrackingFormField!]!) {
  tracking {
    submitHubspotForm(formId: $formId, formInput: $formInput)
  }
}
    `) as unknown as TypedDocumentString<SubmitFormMutation, SubmitFormMutationVariables>;
export const SubmitUserCreatedAccountFormDocument = new TypedDocumentString(`
    mutation SubmitUserCreatedAccountForm($country: SupportedCountry!) {
  tracking {
    submitUserCreatedAccountForm(country: $country)
  }
}
    `) as unknown as TypedDocumentString<SubmitUserCreatedAccountFormMutation, SubmitUserCreatedAccountFormMutationVariables>;
export const UserListQueryDocument = new TypedDocumentString(`
    query UserListQuery($pagination: UserListPagination, $orderBy: UserListOrderBy, $filter: UserListFilter) {
  user {
    userList(pagination: $pagination, orderBy: $orderBy, filter: $filter) {
      id
      username
      name
      status {
        australianMediaValue
        australianCreative
        newZealandCreative
        adminProducts
      }
      createdAt
      updatedAt
      memberships {
        teamId
        team {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UserListQueryQuery, UserListQueryQueryVariables>;
export const UserUpdateSessionMetadataMutationDocument = new TypedDocumentString(`
    mutation UserUpdateSessionMetadataMutation($user: UserUpdateSessionMetadataInput!) {
  user {
    userUpdateSessionMetadata(mutation: $user) {
      id
      name
      createdAt
      updatedAt
      phone
    }
  }
}
    `) as unknown as TypedDocumentString<UserUpdateSessionMetadataMutationMutation, UserUpdateSessionMetadataMutationMutationVariables>;
export const UserItemQueryDocument = new TypedDocumentString(`
    query UserItemQuery($id: String!) {
  user {
    user(userId: $id) {
      id
      username
      name
      status {
        australianMediaValue
        australianCreative
        newZealandCreative
        adminProducts
      }
      createdAt
      updatedAt
      memberships {
        teamId
        team {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UserItemQueryQuery, UserItemQueryQueryVariables>;
export const ReportChangeOwnershipMutationDocument = new TypedDocumentString(`
    mutation ReportChangeOwnershipMutation($input: ReportChangeOwnershipInput!) {
  reportV2 {
    reportChangeOwnership(input: $input) {
      report {
        id
        user {
          id
          name
        }
        teamId
        teamName
        name
        description
        iconName
        iconColor
        sharing {
          status
          usersWithAccess {
            id
            name
            email
          }
        }
        createdAt
        updatedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ReportChangeOwnershipMutationMutation, ReportChangeOwnershipMutationMutationVariables>;
export const SegmentV2ChangeOwnershipDocument = new TypedDocumentString(`
    mutation SegmentV2ChangeOwnership($input: SegmentV2ChangeOwnership!) {
  segmentV2 {
    segmentChangeOwnership(input: $input) {
      id
      name
      color
      teamId
      teamName
      description
      definitionV2
      author {
        id
        name
      }
      sharing {
        status
        usersWithAccess {
          id
          name
        }
      }
      createdAt
      updatedAt
      status
    }
  }
}
    `) as unknown as TypedDocumentString<SegmentV2ChangeOwnershipMutation, SegmentV2ChangeOwnershipMutationVariables>;
export const ViewerQueryDocument = new TypedDocumentString(`
    query ViewerQuery($options: ViewerQueryOptions) {
  viewer(options: $options) {
    id
    userOnboardingInfo {
      isAustraliaOnboarded
    }
    teams {
      id
      name
      role
      products {
        product
        industryIds
        industries
        mediaTypes
        mediaTypeIds
        status
        metadata
        country
        compliance {
          AU {
            AANA_CODE_OF_ETHICS
            AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE
            AANA_CHILDRENS_ADVERTISING_CODE
            AANA_ENVIRONMENTAL_CLAIMS_CODE
            AANA_WAGERING_ADVERTISING_CODE
            FCAI_CODE
            TGA_CODE
            ABAC_CODE
          }
        }
      }
      trialExpired
      hasTrialTeamName
      requestedNzTrial
      downloadCount
    }
    user {
      firstname
      id
      lastname
      name
      username
      createdAt
      registrationStatus
      sessionMetadata
    }
  }
}
    `) as unknown as TypedDocumentString<ViewerQueryQuery, ViewerQueryQueryVariables>;